<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Gerar CTE em Lote</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip.hover.left="'Gerar CTE em Lote'" v-if="getPermission('pedido.store')"><i class="ft-plus step-gerar"></i></a></li>
                                    <li><a @click="onImportXml()" v-b-tooltip title="Importar XML NFe" v-if="getPermission('xmlnfe.import')"><i class="ft-codepen"></i></a></li>
                                    <li><a @click="onImportXmlCte()" v-b-tooltip title="Importar XML CTe" v-if="getPermission('xmlcte.import')"><i class="ft-codepen"></i></a></li>
                                    <li><a @click="onOcultar(2, null, false)" v-b-tooltip title="Mostrar Documentos"><i class="ft-eye"></i></a></li>
                                    <li><a @click="onOcultar(1, null, false)" v-b-tooltip title="Ocultar Documentos"><i class="ft-eye-off"></i></a></li>
                                    <li><a @click="onShowHelp()" v-b-tooltip title="Ajuda"><i class="ft-help-circle"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                <div>
                                <vuetable ref="vuetable"
                                    api-url="/api/gerarcte"
                                    :fields="fields"
                                    :css="css"
                                    :append-params="moreParams"
                                    track-by="docfis_id"
                                    pagination-path=""
                                    @vuetable:pagination-data="onPaginationData"
                                    @vuetable:cell-clicked="onDetail"
                                    @vuetable:loaded="onLoaded"
                                    detail-row-component="cte-veiculo-detalhes"
                                  >
                                  <template slot="actions" slot-scope="props">
                                    <div class="custom-actions">
                                        <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                        <a v-if="props.rowData.ocultar==2" @click="onOcultar(1, props.rowData, true)" v-b-tooltip title="Ocultar"><i class="fa fa-eye-slash"></i></a>
                                        <a v-if="props.rowData.ocultar==1" @click="onOcultar(2, props.rowData, true)" v-b-tooltip title="Mostrar"><i class="fa fa-eye"></i></a>
                                    </div>
                                  </template>
                              </vuetable>
                            </div>
                            <div>
                                <div class='col-md-12'>
                                    <div class="pull-left pagination-detail">
                                        <vuetable-pagination-info ref="paginationInfo"
                                                                  :css="css.pagination"
                                                                  info-class="pull-left"
                                        ></vuetable-pagination-info>
                                    </div>
                                    <div class="pull-right m-a-0">
                                        <vuetable-pagination ref="pagination"
                                                             :css="css.pagination"
                                                             @vuetable-pagination:change-page="onChangePage"
                                        ></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

                    <!-- Modal Component -->
                    <b-modal id="modal_help"
                             ref="modal_help"
                             :title="modal_titulo"
                             close-title="Fechar"
                             v-model="showModalHelp"
                             size="lg">
                        <b-container fluid class="p-a-0">
                            Você não precisa selecionar um documento na listagem, pode clicar diretamente no botão + e criar um CTE baseado nas características próprias <br/>
                            Lembre-se de levar em conta as seguintes características:<br/>
                            1) CTE Normal precisa de documento de carga ( Seja NFe, NF, Declaração, outros ) <br/>
                            2) Redespacho necessita dois dois documentos ( de carga e anterior ) <br/>
                            3) Redespacho intermediário necessita apenas de documento anterior de transporte<br/>
                            4) Vinculado a multimodal não necessita de documentos vinculados.<br/><br/>
                            Caso prefira, você pode selecionar as notas fiscais na listagem e gerar o CTE, se atendando aos seguintes fatores:<br/>
                            1) Caso tenha mais de um destinatário ou remente colocar o CTE como Globalizado ( Verificar se o seu Estado já permite essa operação )<br/>
                            2) O tomador do serviço do CTE será o mesmo para todos os CTE's globalizados. E no DACTE o destinatario ou remetente ficará como "Diversos"<br/>
                        </b-container>
                    </b-modal>

                    <!-- Modal Component -->
                    <b-modal id="modal_upload_xml"
                             ref="modal_upload_xml"
                             :title="modal_titulo"
                             :ok-title="modal_botao"
                             close-title="Fechar"
                             v-model="showModalXml"
                             >
                             <div class="col-md-12 col-sm-12">
                                 <label>Importar XML de NFe </label>
                                 <vue-dropzone ref="myVueDropzone" id="dropzone"
                                    :include-styling="true"
                                     v-on:vdropzone-success="showSuccess"
                                     v-on:vdropzone-error="showError"
                                     v-on:vdropzone-sending="sendingEvent"
                                     :options="dzOptions">
                                 </vue-dropzone>
                             </div>
                         <div slot="modal-footer" class="w-100">
                                <div class="float-right">
                                    <b-btn @click="showModalXml=false" variant="secondary">
                                      Fechar
                                    </b-btn>
                                </div>
                         </div>
                    </b-modal>

                    <!-- Modal Component -->
                    <b-modal id="modal_upload_xml_cte"
                             ref="modal_upload_xml_cte"
                             :title="modal_titulo"
                             :ok-title="modal_botao"
                             close-title="Fechar"
                             v-model="showModalXmlCTe"
                             >
                             <div class="col-md-12 col-sm-12">
                                 <label>Importar XML de CTe </label>
                                 <vue-dropzone ref="myVueDropzoneCTe" id="dropzoneCTe"
                                    :include-styling="true"
                                     v-on:vdropzone-success="showSuccess"
                                     v-on:vdropzone-error="showErrorCTe"
                                     v-on:vdropzone-sending="sendingEvent"
                                     :options="dzOptionsCTe">
                                 </vue-dropzone>
                             </div>
                         <div slot="modal-footer" class="w-100">
                                <div class="float-right">
                                    <b-btn @click="showModalXmlCTe=false" variant="secondary">
                                      Fechar
                                    </b-btn>
                                </div>
                         </div>
                    </b-modal>


                    <!-- Modal Component -->
                    <b-modal id="modal_sel_cte_form"
                             ref="modal_sel_cte_form"
                             :title="modal_titulo"
                             :ok-title="modal_botao"
                             close-title="Fechar"
                             v-model="showModalSelect"
                             :ok-disabled=form.errors.any()
                             @ok="handleOk">

                             <span v-if="!certificado_instalado">
                                <b-alert variant="warning" show>Atenção, não há certificado A1 configurado para emissão do CTE. Favor configurar na tela de configurações da conta </b-alert>
                             </span>

                             <div class="col-md-12 col-sm-12 gerar-cte-modal-modelo">
                                 <label>Modelo </label>
                                 <multiselect v-model="form.modelo_cte"
                                 :options="optionsModelo"
                                 track-by="value"
                                 label="label"
                                 :hide-selected="true"
                                 placeholder="Selecione"
                                 tag-placeholder="Selecionar"
                                 select-label="Selecionar"
                                 selected-label="Selecionado"
                                 deselect-label="Remover"
                                 ></multiselect>
                                 <b-form-feedback v-text="form.errors.get('modelo_cte.value')" v-if="form.errors.has('modelo_cte.value')"></b-form-feedback>
                                 <small> A utilização de um modelo é opcional</small>

                             </div>
                             <div class="row bs-glyphicons">
                                <div class="col-md-12"><label>Selecione o Modal do CTE</label></div>
                                <div class="col-md-4 text-center">
                                    <a href='#' @click="onGerarCte($event, 3)">
                                        <div class="alert alert-blue-dirty alert-fill m-a">
                                            <i class="fa fa-2x fa-ship" aria-hidden="true"></i> <br/>Aquaviário
                                        </div>
                                    </a>
                                </div>

                                <div class="col-md-4 text-center">
                                    <a href='#' @click="onGerarCte($event, 1)">
                                        <div class="alert alert-blue-dirty alert-fill m-a">
                                            <i class="fa fa-2x fa-truck" aria-hidden="true"></i> <br/>Rodoviário
                                        </div>
                                    </a>
                                </div>

                                <div style="pointer-events:none;opacity:0.2" class="col-md-4 text-center">
                                    <a  href='#' @click="onGerarCte($event, 2)">
                                        <div class="alert alert-blue-dirty alert-fill m-a">
                                            <i class="fa fa-2x fa-plane" aria-hidden="true"></i> <br/>Aéreo
                                        </div>
                                    </a>
                                </div>

                                <div class="col-md-4 text-center m-t-md">
                                    <a href='#' @click="onGerarCte($event, 6)">
                                        <div class="alert alert-blue-dirty alert-fill m-a">
                                            <i class="fa fa-2x fa-tasks" aria-hidden="true"></i> <br/>Multimodal
                                        </div>
                                    </a>
                                </div>

                                <div style="pointer-events:none;opacity:0.2" class="col-md-4 text-center m-t-md">
                                    <a href='#' @click="onGerarCte($event, 4)">
                                        <div class="alert alert-blue-dirty alert-fill m-a">
                                            <i class="fa fa-2x fa-train" aria-hidden="true"></i> <br/>Ferroviário
                                        </div>
                                    </a>
                                </div>

                                <div style="pointer-events:none;opacity:0.2" class="col-md-4 text-center m-t-md">
                                    <a href='#' @click="onGerarCte($event, 5)">
                                        <div class="alert alert-blue-dirty alert-fill m-a">
                                            <i class="fa fa-2x fa-minus" aria-hidden="true"></i> <br/>Dutoviário
                                        </div>
                                    </a>
                                </div>

                             </div>

                         <div slot="modal-footer" class="w-100">
                                <div class="float-right">
                                    <b-btn @click="showModalSelect=false" variant="secondary">
                                      Fechar
                                    </b-btn>
                                </div>
                         </div>
                    </b-modal>
                    <!-- Modal Component -->
                    <b-modal id="modal_form"
                             ref="modal_form"
                             size="lg"
                             :title="modal_titulo"
                             :ok-title="modal_botao"
                             close-title="Fechar"
                             v-model="showModal"
                             :ok-disabled=form.errors.any()
                             @ok="handleOk">
                        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
                            <b-container fluid class="p-a-0">
                                <b-row>
                                    <b-col>
                                        <label>CST *</label>
                                        <multiselect v-model="form.cst"
                                        :options="optionsParamCst"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Selecione"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('cst.value')" v-if="form.errors.has('cst.value')"></b-form-feedback>
                                    </b-col>

                                    <b-col class="p-l-0">
                                        <label>CFOP *</label>
                                        <multiselect v-model="form.cfop"
                                        :options="optionsLivCfop"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Selecione"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('cfop.value')" v-if="form.errors.has('cfop.value')"></b-form-feedback>
                                    </b-col>

                                    <b-col class="p-l-0">
                                        <label>Tipo serviço *</label>
                                        <multiselect v-model="form.tp_servico"
                                        :options="optionsLivTpServico"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Selecione"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('tp_servico.value')" v-if="form.errors.has('tp_servico.value')"></b-form-feedback>
                                    </b-col>

                                    <b-col class="p-l-0">
                                      <label>Valor Carga * <span v-b-tooltip title="Indica o valor da NF a ser utilizado no campo Valor da Carga do CTE" placement="top">[?]</span></label>
                                      <multiselect v-model="form.tp_valor_carga"
                                      :options="optionsLivTpValorCarga"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('tp_valor_carga.value')" v-if="form.errors.has('tp_valor_carga.value')"></b-form-feedback>
                                    </b-col>

                                    <b-col class="p-l-0">
                                      <label>Globalizado * <span v-b-tooltip title="Caso seja SIM, o literal diversos será usado no destinatário e vários Destinatário serão possíveis no CTE" placement="top">[?]</span></label>
                                      <multiselect v-model="form.globalizado"
                                      :options="optionsLivGlobalizado"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('globalizado.value')" v-if="form.errors.has('globalizado.value')"></b-form-feedback>
                                    </b-col>

                                </b-row>
                                <b-row v-if="form.tp_servico.value==4">
                                  <b-col>
                                      <label>Chave CTE Multimodal</label>
                                      <b-form-input type="text"
                                                  placeholder="Chave"
                                                  v-model="form.chave_cte_multi"
                                                  name="chave_cte_multi"
                                                  >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('chave_cte_multi')" v-if="form.errors.has('chave_cte_multi')"></b-form-feedback>
                                  </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <label>Municipio Inicio * </label>
                                        <multiselect v-model="form.municipio_ini"
                                        :options="optionsMunicipioIni"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Selecione"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_ini.value')" v-if="form.errors.has('municipio_ini.value')"></b-form-feedback>
                                    </b-col>

                                    <b-col class="p-l-0">
                                        <label>Municipio Fim * </label>
                                        <multiselect v-model="form.municipio_fim"
                                        :options="optionsMunicipioFim"
                                        track-by="value"
                                        label="label"
                                        :hide-selected="true"
                                        placeholder="Selecione"
                                        tag-placeholder="Selecionar"
                                        select-label="Selecionar"
                                        selected-label="Selecionado"
                                        deselect-label="Remover"
                                        ></multiselect>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_fim.value')" v-if="form.errors.has('municipio_fim.value')"></b-form-feedback>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <label>Produto Predominante * <span v-b-tooltip title="Máximo de 60 caracteres" placement="top">[?]</span> ( {{produto_predominante_left}} )</label>
                                        <b-form-input type="text"
                                                    placeholder="Produto Predominante"
                                                    v-model="form.produto_predominante"
                                                    name="cst"
                                                    >
                                        </b-form-input>

                                        <b-form-feedback class="text-danger" v-text="form.errors.get('produto_predominante')" v-if="form.errors.has('produto_predominante')"></b-form-feedback>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col>
                                        <br/>
                                        <h3 class="panel-title with-border">Valores</h3>
                                    </b-col>
                                </b-row>
                              <b-row>
                                <b-col class="p-0">
                                  <label>Valor Liquido * </label>
                                  <currency-input
                                      class="form-control"
                                      v-model="form.vlr_cte"
                                      placeholder=""

                                      :auto-decimal-mode="true"
                                      :locale="getCurrency.locale"
                                      style="text-align: right"
                                      v-on:keyup="calcCte"
                                      :currency="{ prefix: 'R$ '}"
                                      :distraction-free="getCurrency"/>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_cte')" v-if="form.errors.has('vlr_cte')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-0">
                                  <label>Valor Averbação</label>
                                  <currency-input
                                      class="form-control"
                                      v-model="form.vlr_carga_averbacao"
                                      placeholder=""
                                      :auto-decimal-mode="true"
                                      :locale="getCurrency.locale"
                                      style="text-align: right"
                                      v-on:keyup="calcCte"
                                      :currency="{ prefix: 'R$ '}"
                                      :distraction-free="getCurrency"/>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_carga_averbacao')" v-if="form.errors.has('vlr_carga_averbacao')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-0">
                                  <label>Alíquota</label>
                                  <currency-input
                                      class="form-control"
                                      v-model="form.vlr_aliquota"
                                      placeholder=""
                                      :auto-decimal-mode="true"
                                      :locale="getCurrency.locale"
                                      style="text-align: right"
                                      v-on:keyup="calcCte"
                                      :currency="{ prefix: '% '}"
                                      :distraction-free="getCurrency"/>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota')" v-if="form.errors.has('vlr_aliquota')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-0" v-if="this.cd_cst==90 || this.cd_cst==20">
                                  <label>% Redução BC</label>
                                  <currency-input
                                      class="form-control"
                                      v-model="form.percentual_reducao_bc"
                                      placeholder=""
                                      :auto-decimal-mode="true"
                                      :locale="getCurrency.locale"
                                      style="text-align: right"
                                      v-on:keyup="calcCte"
                                      :currency="{ prefix: '% '}"
                                      :distraction-free="getCurrency"/>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('percentual_reducao_bc')" v-if="form.errors.has('percentual_reducao_bc')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-0">
                                  <label>Imposto</label>
                                  <currency-input
                                      class="form-control"
                                      v-model="form.vlr_imposto"
                                      placeholder=""
                                      disabled
                                      :auto-decimal-mode="true"
                                      :locale="getCurrency.locale"
                                      style="text-align: right"
                                      v-on:keyup="calcCte"
                                      :currency="{ prefix: 'R$ '}"
                                      :distraction-free="getCurrency"/>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_imposto')" v-if="form.errors.has('vlr_imposto')"></b-form-feedback>
                                </b-col>
                                <b-col class="p-0">
                                  <label>Valor Total do CTE</label>
                                  <currency-input
                                      class="form-control"
                                      v-model="form.vlr_total"
                                      placeholder=""
                                      disabled
                                      :auto-decimal-mode="true"
                                      :locale="getCurrency.locale"
                                      style="text-align: right"
                                      v-on:keyup="calcCte"
                                      :currency="{ prefix: 'R$ '}"
                                      :distraction-free="getCurrency"/>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_total')" v-if="form.errors.has('vlr_total')"></b-form-feedback>
                                </b-col>
                              </b-row>

                            </b-container>

                            <b-container fluid class="p-a-0" v-if="this.form.modal==3">
                                <b-row>
                                    <b-col>
                                        <br/>
                                        <h3 class="panel-title with-border">CTE <b-badge> Aquaviário </b-badge></h3>
                                    </b-col>
                                </b-row>
                                <b-row>
                                  <b-col>
                                      <label>Porto de Origem * </label>
                                      <multiselect v-model="form.porto_origem"
                                      :options="optionsPortoOrigem"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('porto_origem.value')" v-if="form.errors.has('porto_origem.value')"></b-form-feedback>
                                    </b-col>
                                    <b-col>

                                      <label>Porto de Transbordo</label>
                                      <multiselect v-model="form.porto_transbordo"
                                      :options="optionsPortoTransbordo"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('porto_transbordo.value')" v-if="form.errors.has('porto_transbordo.value')"></b-form-feedback>
                                    </b-col>
                                    <b-col>

                                      <label>Porto de Destino * </label>
                                      <multiselect v-model="form.porto_destino"
                                      :options="optionsPortoDestino"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('porto_destino.value')" v-if="form.errors.has('porto_destino.value')"></b-form-feedback>
                                    </b-col>
                                  </b-row>

                                  <b-row>
                                    <b-col>
                                      <label>Embarcação * </label>
                                      <multiselect v-model="form.embarcacao"
                                      :options="optionsEmbarcacao"
                                      track-by="value"
                                      label="label"
                                      :hide-selected="true"
                                      placeholder="Selecione"
                                      tag-placeholder="Selecionar"
                                      select-label="Selecionar"
                                      selected-label="Selecionado"
                                      deselect-label="Remover"
                                      ></multiselect>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('embarcacao.value')" v-if="form.errors.has('embarcacao.value')"></b-form-feedback>
                                    </b-col>
                                  <b-col>
                                      <label>Nº da Viagem * </label>
                                      <b-form-input type="text"
                                                    placeholder="Nº da Viagem"
                                                    v-model="form.num_viagem"
                                                    name="num_viagem"
                                                    >
                                      </b-form-input>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('num_viagem')" v-if="form.errors.has('num_viagem')"></b-form-feedback>
                                </b-col>
                                    <b-col class="p-0">
                                      <label>% Afrmm</label>
                                      <currency-input
                                          class="form-control"
                                          v-model="form.vlr_aliquota_afrmm"
                                          placeholder=""
                                          :auto-decimal-mode="true"
                                          :locale="getCurrency.locale"
                                          style="text-align: right"
                                          v-on:keyup="calcCte"
                                          :currency="{ prefix: '% '}"
                                          :distraction-free="getCurrency"/>
                                      <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_aliquota_afrmm')" v-if="form.errors.has('vlr_aliquota_afrmm')"></b-form-feedback>
                                    </b-col>
                            </b-row>
                        </b-container>
                          <b-container fluid class="p-a-0" v-if="this.form.modal==1">
                              <b-row>
                                  <b-col>
                                      <br/>
                                      <h3 class="panel-title with-border">CTE <b-badge> Rodoviário </b-badge></h3>
                                  </b-col>
                              </b-row>
                              <b-row>
                              <b-col>
                                  <label>RNTRC * </label>
                                  <input v-model.lazy="form.rntrc"
                                     name="rntrc"
                                     type="text"
                                     class="form-control"/>
                                  <b-form-feedback class="text-danger" v-text="form.errors.get('rntrc')" v-if="form.errors.has('rntrc')"></b-form-feedback>
                              </b-col>
                              </b-row>
                          </b-container>
                            <b-container fluid class="p-a-0" v-if="this.form.modal==6">
                                <b-row>
                                    <b-col>
                                        <br/>
                                        <h3 class="panel-title with-border">CTE <b-badge> Multimodal </b-badge></h3>
                                    </b-col>
                                </b-row>
                                <b-row>
                                <b-col>
                                    <label>COTM * <span v-b-tooltip title="Certificado de operação de transporte multimodal. Obrigatório para CTE multimodal" placement="top">[?]</span></label>
                                    <input v-model.lazy="form.cotm"
                                       name="cotm"
                                       type="text"
                                       class="form-control"/>
                                    <b-form-feedback class="text-danger" v-text="form.errors.get('cotm')" v-if="form.errors.has('cotm')"></b-form-feedback>
                                </b-col>
                                </b-row>
                            </b-container>
                            <b-container fluid class="p-a-0">
                              <b-row>
                                <b-col>
                                    <br/>
                                    <h3 class="panel-title">Detalhes do CTE </h3>
                                    <b-tabs>
                                      <b-tab title="Partes Envolvidas" active>
                                          <b-row>
                                              <b-col>
                                                <label>Expedidor</label>
                                                <multiselect v-model="form.expedidor"
                                                :options-limit="300"
                                                :limit="2"
                                                :limit-text="limitText"
                                                :options="optionsExpedidor"
                                                track-by="value"
                                                label="label"
                                                :hide-selected="true"
                                                placeholder="Expedidor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                                tag-placeholder="Selecionar"
                                                select-label="Selecionar"
                                                selected-label="Selecionado"
                                                deselect-label="Remover"
                                                :searchable="true"
                                                :loading="isLoadingExp"
                                                @search-change="listaClientesExpedidor"
                                                ></multiselect>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('expedidor')" v-if="form.errors.has('expedidor')"></b-form-feedback>
                                              </b-col>
                                          </b-row>
                                          <b-row>
                                              <b-col>
                                                <label>Recebedor</label>
                                                <multiselect v-model="form.recebedor"
                                                :options-limit="300"
                                                :limit="2"
                                                :limit-text="limitText"
                                                :options="optionsRecebedor"
                                                track-by="value"
                                                label="label"
                                                :hide-selected="true"
                                                placeholder="Recebedor ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                                tag-placeholder="Selecionar"
                                                select-label="Selecionar"
                                                selected-label="Selecionado"
                                                deselect-label="Remover"
                                                :searchable="true"
                                                :loading="isLoadingRec"
                                                @search-change="listaClientesRecebedor"
                                                ></multiselect>
                                                <b-form-feedback class="text-danger" v-text="form.errors.get('recebedor')" v-if="form.errors.has('recebedor')"></b-form-feedback>
                                              </b-col>
                                          </b-row>

                                          <b-row>
                                              <b-col>
                                                  <label>Tomador</label>
                                                    <b-form-radio-group buttons button-variant="secondary" v-model="form.tomador" name="tomador">
                                                      <b-form-radio value="0"> Remetente</b-form-radio>
                                                      <b-form-radio value="1"> Expedidor</b-form-radio>
                                                      <b-form-radio value="2"> Recebedor</b-form-radio>
                                                      <b-form-radio value="3"> Destinatário</b-form-radio>
                                                      <b-form-radio value="4"> Outros</b-form-radio>
                                                    </b-form-radio-group>
                                                    <b-form-feedback class="text-danger" v-text="form.errors.get('tomador')" v-if="form.errors.has('tomador')"></b-form-feedback>
                                                </b-col>
                                            </b-row>
                                            <b-row v-if="form.tomador==4">
                                                <b-col>
                                                  <label>Tomador - Outros</label>
                                                  <multiselect v-model="form.tomador_outros"
                                                  :options-limit="300"
                                                  :limit="2"
                                                  :limit-text="limitText"
                                                  :options="optionsTomador"
                                                  track-by="value"
                                                  label="label"
                                                  :hide-selected="true"
                                                  placeholder="Tomador ( Digite ao menos 3 caracteres, CNPJ, Código, IE ou Razão Social )"
                                                  tag-placeholder="Selecionar"
                                                  select-label="Selecionar"
                                                  selected-label="Selecionado"
                                                  deselect-label="Remover"
                                                  :searchable="true"
                                                  :loading="isLoadingTom"
                                                  @search-change="listaClientesTomador"
                                                  ></multiselect>
                                                  <b-form-feedback class="text-danger" v-text="form.errors.get('tomador_outros.value')" v-if="form.errors.has('tomador_outros.value')"></b-form-feedback>
                                                </b-col>
                                            </b-row>
                                      </b-tab>
                                      <b-tab title="Carga">
                                        <table class="table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 30%">Unidade de medida * </th>
                                                    <th style="width: 30%">Tipo de medida * </th>
                                                    <th style="width: 30%">Quantidade carga * </th>
                                                    <th style="width: 10%">Ações</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                 <tr v-for="(row, index) in carga_medida" class="bg-gray-light" style="display: table-row;">
                                                    <td>
                                                      <b-col>
                                                          <multiselect v-model="row.medida"
                                                          :options="optionsParamUnidadeMedida"
                                                          track-by="value"
                                                          label="label"
                                                          :hide-selected="true"
                                                          placeholder="Selecione"
                                                          tag-placeholder="Selecionar"
                                                          select-label="Selecionar"
                                                          selected-label="Selecionado"
                                                          deselect-label="Remover"
                                                          ></multiselect>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('carga_medida.'+index+'.medida.value')" v-if="form.errors.has('carga_medida.'+index+'.medida.value')"></b-form-feedback>
                                                      </b-col>
                                                    </td>
                                                    <td>
                                                      <b-col>
                                                          <multiselect v-model="row.tipomedida"
                                                          :options="optionsParamTipoMedida"
                                                          track-by="value"
                                                          label="label"
                                                          :hide-selected="true"
                                                          placeholder="Selecione"
                                                          tag-placeholder="Selecionar"
                                                          select-label="Selecionar"
                                                          selected-label="Selecionado"
                                                          deselect-label="Remover"
                                                          ></multiselect>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('carga_medida.'+index+'.tipomedida.value')" v-if="form.errors.has('carga_medida.'+index+'.tipomedida.value')"></b-form-feedback>
                                                      </b-col>
                                                    </td>
                                                   <td>
                                                     <currency-input
                                                         class="form-control"
                                                         v-model="row.qtde_carga"
                                                         placeholder=""
                                                         :locale="getCurrency.locale"
                                                         :precision="3"
                                                         style="text-align: right"
                                                         v-on:keyup="calcCte"
                                                         :currency="{ prefix: ''}"
                                                         :distraction-free="getCurrency"/>
                                                     <b-form-feedback class="text-danger" v-text="form.errors.get('carga_medida.'+index+'.qtde_carga')" v-if="form.errors.has('carga_medida.'+index+'.qtde_carga')"></b-form-feedback>
                                                   </td>
                                                    <td>
                                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowCarga(index);"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <td></td><td></td><td></td>
                                            <td>
                                              <i class="fa fa-plus-square" v-on:click="addRowCarga($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                            </td>
                                        </table>
                                      </b-tab>
                                      <b-tab title="Documentos">
                                          <table class="table-striped">
                                              <thead>
                                                  <tr>
                                                      <th style="width: 5%">Tipo</th>
                                                      <th style="width: 30%">Doc Carga - Emitente</th>
                                                      <th style="width: 15%">Chave</th>
                                                      <th style="width: 10%">Nº Fiscal</th>
                                                      <th style="width: 10%">Série</th>
                                                      <th style="width: 15%">Data</th>
                                                      <th style="width: 5%">Ação</th>
                                                  </tr>
                                               </thead>
                                               <tbody>
                                                   <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in docfis">
                                                      <td>
                                                          {{ row.tp_doc.descr }}
                                                      </td>
                                                      <td>
                                                          {{ row.emi_nome }}
                                                      </td>
                                                      <td>
                                                          <span v-if="row.tp_doc.valor==1">
                                                              <b-btn class="badge badge-warning" @click="showPopoverChaveNFe = !showPopoverChaveNFe" :id="'popoverButtonChaveNFe-sync'+row.chave" v-b-tooltip.hover.right="'Clique aqui para ver a chave completa ( Todas )'" variant="warning">{{ row.chave.substr(34,10) }}</b-btn>

                                                                <b-popover :show.sync="showPopoverChaveNFe" :target="'popoverButtonChaveNFe-sync'+row.chave" title="" data-html="true" placement="top">
                                                                    {{ row.chave }}
                                                                </b-popover>
                                                          </span>
                                                      </td>
                                                      <td>
                                                          {{ row.num_fiscal }}
                                                      </td>
                                                      <td>
                                                          {{ row.serie }}
                                                      </td>
                                                      <td>
                                                          <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                                      </td>
                                                      <td>
                                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDoc(index);"></i>
                                                      </td>
                                                  </tr>
                                                  <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in docfisDig">
                                                     <td>
                                                          {{ row.tp_doc_descr }}
                                                     </td>
                                                     <td>
                                                         {{ row.emi_nome }}
                                                     </td>
                                                     <td>
                                                         <span v-if="row.tp_doc.valor==1">
                                                             <b-btn class="badge badge-warning" @click="showPopoverChaveNFe = !showPopoverChaveNFe" :id="'popoverButtonChaveNFe-sync'+row.chave" v-b-tooltip.hover.right="'Clique aqui para ver a chave completa ( Todas )'" variant="warning">{{ row.chave.substr(34,10) }}</b-btn>

                                                               <b-popover :show.sync="showPopoverChaveNFe" :target="'popoverButtonChaveNFe-sync'+row.chave" title="" data-html="true" placement="top">
                                                                   {{ row.chave }}
                                                               </b-popover>
                                                         </span>
                                                     </td>
                                                     <td>
                                                         {{ row.num_fiscal }}
                                                     </td>
                                                     <td>
                                                         {{ row.serie }}
                                                     </td>
                                                     <td>
                                                         <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                                     </td>
                                                     <td>
                                                         <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDocDig(index);"></i>
                                                     </td>
                                                 </tr>
                                              </tbody>
                                          </table>

                                          <b-tabs style="width: 100%">
                                              <b-tab title="NFe" active>
                                                  <b-container fluid>
                                                      <b-row>
                                                          <b-col sm="8" md="8" class="m-t-5px">
                                                              <label>Chave NFe</label>
                                                              <b-form-input type="text"
                                                                           placeholder="Chave NFe"
                                                                           v-model="helpForm.chave"
                                                                           >
                                                              </b-form-input>
                                                              <b-form-feedback class="text-danger" v-text="helpForm.errors.get('chave')" v-if="helpForm.errors.has('chave')"></b-form-feedback>
                                                          </b-col>
                                                          <b-col sm="4" md="4" class="m-t-5px">
                                                              <div class="float-right">
                                                                  <label> - </label>

                                                                  <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDoc($event);" v-b-tooltip.hover.right="'Adicionar NFe'" style="cursor: pointer">
                                                                  Adicionar
                                                                  </b-btn>

                                                                  <b-btn variant="secondary" :disabled="isDisabled" v-on:click="onBuscarDoc();" v-b-tooltip.hover.right="'Buscar Doc'" style="cursor: pointer">
                                                                  Buscar
                                                                  </b-btn>
                                                              </div>
                                                          </b-col>

                                                      </b-row>
                                                  </b-container>
                                              </b-tab>

                                              <b-tab title="Digitação">
                                                 <b-container fluid class="p-a-0">
                                                     <b-row no-gutters>
                                                         <label><strong>Emitente Documento</strong></label>
                                                     </b-row>
                                                     <b-row no-gutters>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Tipo *</label>
                                                           <multiselect v-model="helpForm.emi_tp_pessoa"
                                                           :options="optionsLivTpPessoa"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder="Selecionar"
                                                           select-label="Selecionar"
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_tp_pessoa.value')" v-if="helpForm.errors.has('emi_tp_pessoa.value')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                             <label>CNPJ/CPF/CUIT</label>
                                                             <b-form-input type="text"
                                                                           placeholder="CNPJ/CPF/CUIT"
                                                                           v-model="helpForm.emi_cnpj_cpf_cuit"
                                                                           >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_cnpj_cpf_cuit')" v-if="helpForm.errors.has('emi_cnpj_cpf_cuit')"></b-form-feedback>
                                                         </b-col>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                             <label>IE</label>
                                                             <b-form-input type="text"
                                                                           placeholder="IE"
                                                                           v-model="helpForm.emi_ie"
                                                                           >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_ie')" v-if="helpForm.errors.has('emi_ie')"></b-form-feedback>
                                                         </b-col>
                                                         <b-col sm="6" md="6" class="m-t-5px p-a-0">
                                                             <label>Nome</label>
                                                             <b-form-input type="text"
                                                                         placeholder="Nome"
                                                                         v-model="helpForm.emi_nome"
                                                                         >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_nome')" v-if="helpForm.errors.has('emi_nome')"></b-form-feedback>
                                                         </b-col>
                                                     </b-row>
                                                     <b-row no-gutters>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>CEP *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="CEP"
                                                                         @change="getCep(1)"
                                                                         v-model="helpForm.emi_cep"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_cep')" v-if="helpForm.errors.has('emi_cep')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Municipio *</label>
                                                           <multiselect v-model="helpForm.emi_municipio"
                                                           :options="optionsMunicipios"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder="Selecionar"
                                                           select-label="Selecionar"
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_municipio.value')" v-if="helpForm.errors.has('emi_municipio.value')"></b-form-feedback>
                                                         </b-col>


                                                         <b-col sm="3" md="3" class="m-t-5px p-a-0">
                                                           <label>Endereço *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Endereço"
                                                                         v-model="helpForm.emi_endereco"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_endereco')" v-if="helpForm.errors.has('emi_endereco')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Número *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Número"
                                                                         v-model="helpForm.emi_numero"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_numero')" v-if="helpForm.errors.has('emi_numero')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Bairro *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Bairro"
                                                                         v-model="helpForm.emi_bairro"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_bairro')" v-if="helpForm.errors.has('emi_bairro')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Complemento</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Complemento"
                                                                         v-model="helpForm.emi_complemento"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('emi_complemento')" v-if="helpForm.errors.has('emi_complemento')"></b-form-feedback>
                                                         </b-col>
                                                     </b-row>

                                                     <b-row no-gutters>
                                                         <label><strong>Destinatário Documento</strong></label>
                                                     </b-row>
                                                     <b-row no-gutters>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Tipo *</label>
                                                           <multiselect v-model="helpForm.des_tp_pessoa"
                                                           :options="optionsLivTpPessoa"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder="Selecionar"
                                                           select-label="Selecionar"
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_tp_pessoa.value')" v-if="helpForm.errors.has('des_tp_pessoa.value')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                             <label>CNPJ/CPF/CUIT</label>
                                                             <b-form-input type="text"
                                                                           placeholder="CNPJ/CPF/CUIT"
                                                                           v-model="helpForm.des_cnpj_cpf_cuit"
                                                                           >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_cnpj_cpf_cuit')" v-if="helpForm.errors.has('des_cnpj_cpf_cuit')"></b-form-feedback>
                                                         </b-col>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                             <label>IE</label>
                                                             <b-form-input type="text"
                                                                           placeholder="IE"
                                                                           v-model="helpForm.des_ie"
                                                                           >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_ie')" v-if="helpForm.errors.has('des_ie')"></b-form-feedback>
                                                         </b-col>
                                                         <b-col sm="4" md="4" class="m-t-5px p-a-0">
                                                             <label>Nome</label>
                                                             <b-form-input type="text"
                                                                         placeholder="Nome"
                                                                         v-model="helpForm.des_nome"
                                                                         >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_nome')" v-if="helpForm.errors.has('des_nome')"></b-form-feedback>
                                                         </b-col>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>PIN Suframa</label>
                                                           <b-form-input type="text"
                                                                         placeholder="PIN"
                                                                         v-model="helpForm.des_pin"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_pin')" v-if="helpForm.errors.has('des_pin')"></b-form-feedback>
                                                         </b-col>
                                                     </b-row>
                                                     <b-row no-gutters>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>CEP *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="CEP"
                                                                         @change="getCep(2)"
                                                                         v-model="helpForm.des_cep"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_cep')" v-if="helpForm.errors.has('des_cep')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Municipio *</label>
                                                           <multiselect v-model="helpForm.des_municipio"
                                                           :options="optionsMunicipios"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder="Selecionar"
                                                           select-label="Selecionar"
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_municipio.value')" v-if="helpForm.errors.has('des_municipio.value')"></b-form-feedback>
                                                         </b-col>


                                                         <b-col sm="3" md="3" class="m-t-5px p-a-0">
                                                           <label>Endereço *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Endereço"
                                                                         v-model="helpForm.des_endereco"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_endereco')" v-if="helpForm.errors.has('des_endereco')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Número *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Número"
                                                                         v-model="helpForm.des_numero"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_numero')" v-if="helpForm.errors.has('des_numero')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Bairro *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Bairro"
                                                                         v-model="helpForm.des_bairro"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_bairro')" v-if="helpForm.errors.has('des_bairro')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Complemento</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Complemento"
                                                                         v-model="helpForm.des_complemento"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('des_complemento')" v-if="helpForm.errors.has('des_complemento')"></b-form-feedback>
                                                         </b-col>
                                                     </b-row>

                                                     <b-row no-gutters>
                                                         <label><strong>Detalhes</strong></label>
                                                     </b-row>
                                                     <b-row no-gutters>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Tipo *</label>
                                                           <multiselect v-model="helpForm.tp_doc"
                                                           :options="optionsLivDocFiscalTpDoc"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder="Selecionar"
                                                           select-label="Selecionar"
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('tp_doc.value')" v-if="helpForm.errors.has('tp_doc.value')"></b-form-feedback>
                                                         </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Nº Fiscal *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Nº Fiscal"
                                                                         v-model="helpForm.num_fiscal"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('num_fiscal')" v-if="helpForm.errors.has('num_fiscal')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Série *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Série"
                                                                         v-model="helpForm.serie"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('serie')" v-if="helpForm.errors.has('serie')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Chave</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Chave"
                                                                         v-model="helpForm.chave"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('chave')" v-if="helpForm.errors.has('chave')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Data *</label>
                                                           <v-date-picker v-model="helpForm.dt_emissao"
                                                                          mode='single'
                                                                          locale="pt-BR"
                                                                          v-mask="'##/##/####'"
                                                                          :popover='{visibility: "focus"}'
                                                                          :attributes='date_attributes'
                                                                          :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                                                          @keyup.enter="doFilter">
                                                           </v-date-picker>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('dt_emissao')" v-if="helpForm.errors.has('dt_emissao')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Volume *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Volume"
                                                                         v-model="helpForm.qtd_volume"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('qtd_volume')" v-if="helpForm.errors.has('qtd_volume')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Peso Bruto *</label>
                                                           <b-form-input type="text"
                                                                         v-money="qtd"
                                                                         placeholder="Peso Bruto"
                                                                         v-model="helpForm.peso_bruto"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('peso_bruto')" v-if="helpForm.errors.has('peso_bruto')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Valor Doc. *</label>
                                                           <b-form-input type="text"
                                                                         v-money="vlr"
                                                                         placeholder="Valor Documento"
                                                                         v-model="helpForm.vlr_total_nfe"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="helpForm.errors.get('vlr_total_nfe')" v-if="helpForm.errors.has('vlr_total_nfe')"></b-form-feedback>
                                                       </b-col>
                                                      </b-row>
                                                      <b-row>
                                                          <b-col sm="10" md="10">
                                                          </b-col>
                                                          <b-col sm="2" md="2" class="text-right">
                                                              <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDocDigitacao($event);" v-b-tooltip.hover.right="'Adicionar Documento'" style="cursor: pointer">
                                                              Adicionar
                                                              </b-btn>
                                                          </b-col>
                                                      </b-row>
                                                  </b-container>
                                              </b-tab>
                                          </b-tabs>
                                      </b-tab>
                                      <b-tab title="Seguro">
                                        <table class="table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 45%">Responsável pelo seguro</th>
                                                    <th style="width: 45%">Seguradora</th>
                                                    <th style="width: 5%">Ações</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                 <tr v-for="(row, index) in seguro">
                                                    <td>
                                                      <b-col>
                                                          <multiselect v-model="row.respseg"
                                                          :options="optionsParamRespSeg"
                                                          track-by="value"
                                                          label="label"
                                                          :hide-selected="true"
                                                          placeholder="Selecione"
                                                          tag-placeholder="Selecionar"
                                                          select-label="Selecionar"
                                                          selected-label="Selecionado"
                                                          deselect-label="Remover"
                                                          ></multiselect>
                                                          <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.respseg.value')" v-if="form.errors.has('seguro.'+index+'.respseg.value')"></b-form-feedback>
                                                      </b-col>
                                                    </td>
                                                    <td>
                                                      <multiselect v-model="row.seguradora"
                                                      :options="optionsSeguradora"
                                                      track-by="value"
                                                      label="label"
                                                      :hide-selected="true"
                                                      placeholder="Selecione"
                                                      tag-placeholder="Selecionar"
                                                      select-label="Selecionar"
                                                      selected-label="Selecionado"
                                                      deselect-label="Remover"
                                                      ></multiselect>
                                                      <b-form-feedback class="text-danger" v-text="form.errors.get('seguro.'+index+'.seguradora.value')" v-if="form.errors.has('seguro.'+index+'.seguradora.value')"></b-form-feedback>
                                                    </td>
                                                    <td>
                                                        <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowSeguro(index);"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <td></td><td></td>
                                            <td>
                                              <i class="fa fa-plus-square" v-on:click="addRowSeguro($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                            </td>
                                        </table>
                                      </b-tab>
                                      <b-tab title="Observações" >
                                          <h4 class="panel-title">Observação Geral </h4>
                                          <b-form-textarea id="textarea1"
                                                           name="obs"
                                                           v-model="form.obs"
                                                           placeholder="Observação"
                                                           :rows="6"
                                                           :max-rows="6">
                                          </b-form-textarea>
                                          <label>( {{ obs_left}} )</label>
                                          <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                                          <h4 class="panel-title">Campos livres contribuinte</h4>
                                            <table class="table-striped">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 45%">Campo</th>
                                                        <th style="width: 45%">Valor</th>
                                                        <th style="width: 10%">Ações</th>
                                                    </tr>
                                                 </thead>
                                                 <tbody>
                                                     <tr v-for="(row, index) in obs_cont">
                                                        <td>
                                                          <b-col>
                                                              <b-form-input type="text"
                                                                          placeholder="Descrição"
                                                                          v-model="row.xcampo"
                                                                          >
                                                              </b-form-input>
                                                              <b-form-feedback class="text-danger" v-text="form.errors.get('obs_cont.'+index+'.xcampo')" v-if="form.errors.has('obs_cont.'+index+'.xcampo')"></b-form-feedback>
                                                          </b-col>
                                                        </td>
                                                        <td>
                                                          <b-col>
                                                              <b-form-input type="text"
                                                                          placeholder="Valor"
                                                                          v-model="row.xtexto"
                                                                          >
                                                              </b-form-input>
                                                              <b-form-feedback class="text-danger" v-text="form.errors.get('obs_cont.'+index+'.xtexto')" v-if="form.errors.has('obs_cont.'+index+'.xtexto')"></b-form-feedback>
                                                          </b-col>
                                                        </td>
                                                        <td>
                                                              <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowObsCont(index);"></i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <td></td><td></td>
                                                <td>
                                                  <i class="fa fa-plus-square" v-on:click="addRowObsCont($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                                </td>
                                            </table>
                                            <h4 class="panel-title">Campos livres fisco</h4>
                                            <table class="table-striped">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 45%">Campo</th>
                                                        <th style="width: 45%">Valor</th>
                                                        <th style="width: 10%">Ações</th>
                                                    </tr>
                                                 </thead>
                                                 <tbody>
                                                     <tr v-for="(row, index) in obs_fisco">
                                                        <td>
                                                          <b-col>
                                                              <b-form-input type="text"
                                                                          placeholder="Descrição"
                                                                          v-model="row.xcampo"
                                                                          >
                                                              </b-form-input>
                                                              <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fisco.'+index+'.xcampo')" v-if="form.errors.has('obs_fisco.'+index+'.xcampo')"></b-form-feedback>
                                                          </b-col>
                                                        </td>
                                                        <td>
                                                          <b-col>
                                                              <b-form-input type="text"
                                                                          placeholder="Valor"
                                                                          v-model="row.xtexto"
                                                                          >
                                                              </b-form-input>
                                                              <b-form-feedback class="text-danger" v-text="form.errors.get('obs_fisco.'+index+'.xtexto')" v-if="form.errors.has('obs_fisco.'+index+'.xtexto')"></b-form-feedback>
                                                          </b-col>
                                                        </td>
                                                        <td>
                                                              <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowObsFisco(index);"></i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <td></td><td></td>
                                                <td>
                                                  <i class="fa fa-plus-square" v-on:click="addRowObsFisco($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                                </td>
                                            </table>
                                      </b-tab>
                                      <b-tab title="Comp. Frete" >
                                        <table class="table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 45%">Componente * </th>
                                                    <th style="width: 45%">Valor * </th>
                                                    <th style="width: 10%">Ações</th>
                                                </tr>
                                             </thead>
                                             <tbody>
                                                 <tr v-for="(row, index) in comp_frete">
                                                    <td>
                                                        <multiselect v-model="row.custo"
                                                        :options="optionsCustos"
                                                        track-by="value"
                                                        label="label"
                                                        :hide-selected="true"
                                                        placeholder="Selecione"
                                                        tag-placeholder="Selecionar"
                                                        select-label="Selecionar"
                                                        selected-label="Selecionado"
                                                        deselect-label="Remover"
                                                        ></multiselect>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.custo.value')" v-if="form.errors.has('comp_frete.'+index+'.custo.value')"></b-form-feedback>
                                                    </td>
                                                    <td>
                                                      <b-col class="p-0">
                                                        <currency-input
                                                            class="form-control"
                                                            v-model="row.vlr"
                                                            placeholder=""
                                                            :precision="2"
                                                            :locale="getCurrency.locale"
                                                            style="text-align: right"
                                                            v-on:keyup="calcCte"
                                                            :currency="{ prefix: 'R$ '}"
                                                            :distraction-free="getCurrency"/>
                                                        <b-form-feedback class="text-danger" v-text="form.errors.get('comp_frete.'+index+'.vlr')" v-if="form.errors.has('comp_frete.'+index+'.vlr')"></b-form-feedback>
                                                      </b-col>
                                                    </td>
                                                    <td>
                                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Linha'" v-on:click="removeRowCompFrete(index);"></i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <td></td><td></td>
                                            <td>
                                              <i class="fa fa-plus-square" v-on:click="addRowCompFrete($event);" v-b-tooltip.hover.right="'Adicionar Linha'" style="cursor: pointer"></i>
                                            </td>
                                        </table>
                                      </b-tab>
                                      <b-tab title="Documentos Anteriores">
                                          <table class="table-striped">
                                              <thead>
                                                  <tr>
                                                      <th style="width: 5%">Tipo</th>
                                                      <th style="width: 30%">Doc Anterior - Emitente</th>
                                                      <th style="width: 15%">Chave</th>
                                                      <th style="width: 10%">Nº Fiscal</th>
                                                      <th style="width: 10%">Série</th>
                                                      <th style="width: 15%">Data</th>
                                                      <th style="width: 5%">Ação</th>
                                                  </tr>
                                               </thead>
                                               <tbody>
                                                   <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in doctransp">
                                                      <td>
                                                          {{ row.tp_doc.descr }}
                                                      </td>
                                                      <td>
                                                          {{ row.emi_nome }}
                                                      </td>
                                                      <td>
                                                          <span v-if="row.tp_doc.valor==1">
                                                              <b-btn class="badge badge-warning" @click="showPopoverChaveCTe = !showPopoverChaveCTe" :id="'popoverButtonChaveCTe-sync'+row.chave" v-b-tooltip.hover.right="'Clique aqui para ver a chave completa ( Todas )'" variant="warning">{{ row.chave.substr(34,10) }}</b-btn>

                                                                <b-popover :show.sync="showPopoverChaveCTe" :target="'popoverButtonChaveCTe-sync'+row.chave" title="" data-html="true" placement="top">
                                                                    {{ row.chave }}
                                                                </b-popover>
                                                          </span>
                                                      </td>
                                                      <td>
                                                          {{ row.num_fiscal }}
                                                      </td>
                                                      <td>
                                                          {{ row.serie }}
                                                      </td>
                                                      <td>
                                                          <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                                      </td>
                                                      <td>
                                                          <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDocTransp(index);"></i>
                                                      </td>
                                                  </tr>
                                                  <tr class="bg-gray-light" style="display: table-row;" v-for="(row, index) in doctranspDig">
                                                     <td>
                                                          {{ row.tp_doc_descr }}
                                                     </td>
                                                     <td>
                                                         {{ row.emi_nome }}
                                                     </td>
                                                     <td>
                                                         <span v-if="row.tp_doc.valor==1">
                                                             <b-btn class="badge badge-warning" @click="showPopoverChaveCTe = !showPopoverChaveCTe" :id="'popoverButtonChaveCTe-sync'+row.chave" v-b-tooltip.hover.right="'Clique aqui para ver a chave completa ( Todas )'" variant="warning">{{ row.chave.substr(34,10) }}</b-btn>

                                                               <b-popover :show.sync="showPopoverChaveCTe" :target="'popoverButtonChaveCTe-sync'+row.chave" title="" data-html="true" placement="top">
                                                                   {{ row.chave }}
                                                               </b-popover>
                                                         </span>
                                                     </td>
                                                     <td>
                                                         {{ row.num_fiscal }}
                                                     </td>
                                                     <td>
                                                         {{ row.serie }}
                                                     </td>
                                                     <td>
                                                         <span>{{ formatDate(row.dt_emissao, 'DD/MM/YYYY') }} </span>
                                                     </td>
                                                     <td>
                                                         <i class="fa fa-times" style="cursor: pointer" v-b-tooltip.hover.right="'Remover Documento'" v-on:click="removeRowDocTranspDig(index);"></i>
                                                     </td>
                                                 </tr>
                                              </tbody>
                                          </table>
                                          <b-tabs style="width: 100%">
                                              <b-tab title="CTe" active>
                                                  <b-container fluid>
                                                      <b-row>
                                                          <b-col sm="10" md="10" class="m-t-5px">
                                                              <label>Chave CTe</label>
                                                              <b-form-input type="text"
                                                                           placeholder="Chave CTe"
                                                                           v-model="form_doctransp.chave"
                                                                           >
                                                              </b-form-input>
                                                              <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('chave')" v-if="form_doctransp.errors.has('chave')"></b-form-feedback>
                                                          </b-col>
                                                          <b-col sm="2" md="2" class="m-t-5px">
                                                              <label> - </label>
                                                              <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDocTransp($event);" v-b-tooltip.hover.right="'Adicionar CTe'" style="cursor: pointer">
                                                              Adicionar
                                                              </b-btn>
                                                          </b-col>
                                                      </b-row>
                                                  </b-container>
                                              </b-tab>

                                              <b-tab title="Digitação">
                                                 <b-container fluid class="p-a-0">
                                                     <b-row no-gutters>
                                                         <label><strong>Emitente Documento</strong></label>
                                                     </b-row>
                                                     <b-row no-gutters>

                                                         <b-col sm="3" md="3" class="m-t-5px p-a-0">
                                                             <label>CNPJ</label>
                                                             <b-form-input type="text"
                                                                           placeholder="CNPJ"
                                                                           v-model="form_doctransp.emi_cnpj_cpf_cuit"
                                                                           >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_cnpj_cpf_cuit')" v-if="form_doctransp.errors.has('emi_cnpj_cpf_cuit')"></b-form-feedback>
                                                         </b-col>
                                                         <b-col sm="9" md="9" class="m-t-5px p-a-0">
                                                             <label>Nome</label>
                                                             <b-form-input type="text"
                                                                         placeholder="Nome"
                                                                         v-model="form_doctransp.emi_nome"
                                                                         >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_nome')" v-if="form_doctransp.errors.has('emi_nome')"></b-form-feedback>
                                                         </b-col>
                                                     </b-row>
                                                     <b-row no-gutters>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>CEP *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="CEP"
                                                                         @change="getCep(3)"
                                                                         v-model="form_doctransp.emi_cep"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_cep')" v-if="form_doctransp.errors.has('emi_cep')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Municipio *</label>
                                                           <multiselect v-model="form_doctransp.emi_municipio"
                                                           :options="optionsMunicipios"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder="Selecionar"
                                                           select-label="Selecionar"
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_municipio.value')" v-if="form_doctransp.errors.has('emi_municipio.value')"></b-form-feedback>
                                                         </b-col>


                                                         <b-col sm="3" md="3" class="m-t-5px p-a-0">
                                                           <label>Endereço *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Endereço"
                                                                         v-model="form_doctransp.emi_endereco"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_endereco')" v-if="form_doctransp.errors.has('emi_endereco')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Número *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Número"
                                                                         v-model="form_doctransp.emi_numero"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_numero')" v-if="form_doctransp.errors.has('emi_numero')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Bairro *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Bairro"
                                                                         v-model="form_doctransp.emi_bairro"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_bairro')" v-if="form_doctransp.errors.has('emi_bairro')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Complemento</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Complemento"
                                                                         v-model="form_doctransp.emi_complemento"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('emi_complemento')" v-if="form_doctransp.errors.has('emi_complemento')"></b-form-feedback>
                                                         </b-col>
                                                     </b-row>

                                                     <b-row no-gutters>
                                                         <label><strong>Destinatário Documento</strong></label>
                                                     </b-row>
                                                     <b-row no-gutters>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Tipo *</label>
                                                           <multiselect v-model="form_doctransp.des_tp_pessoa"
                                                           :options="optionsLivTpPessoa"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder="Selecionar"
                                                           select-label="Selecionar"
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_tp_pessoa.value')" v-if="form_doctransp.errors.has('des_tp_pessoa.value')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                             <label>CNPJ/CPF/CUIT</label>
                                                             <b-form-input type="text"
                                                                           placeholder="CNPJ/CPF/CUIT"
                                                                           v-model="form_doctransp.des_cnpj_cpf_cuit"
                                                                           >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_cnpj_cpf_cuit')" v-if="form_doctransp.errors.has('des_cnpj_cpf_cuit')"></b-form-feedback>
                                                         </b-col>
                                                         <b-col sm="6" md="6" class="m-t-5px p-a-0">
                                                             <label>Nome</label>
                                                             <b-form-input type="text"
                                                                         placeholder="Nome"
                                                                         v-model="form_doctransp.des_nome"
                                                                         >
                                                             </b-form-input>
                                                             <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_nome')" v-if="form_doctransp.errors.has('des_nome')"></b-form-feedback>
                                                         </b-col>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>PIN Suframa</label>
                                                           <b-form-input type="text"
                                                                         placeholder="PIN"
                                                                         v-model="form_doctransp.des_pin"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_pin')" v-if="form_doctransp.errors.has('des_pin')"></b-form-feedback>
                                                         </b-col>
                                                     </b-row>
                                                     <b-row no-gutters>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>CEP *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="CEP"
                                                                         @change="getCep(4)"
                                                                         v-model="form_doctransp.des_cep"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_cep')" v-if="form_doctransp.errors.has('des_cep')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Municipio *</label>
                                                           <multiselect v-model="form_doctransp.des_municipio"
                                                           :options="optionsMunicipios"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder="Selecionar"
                                                           select-label="Selecionar"
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_municipio.value')" v-if="form_doctransp.errors.has('des_municipio.value')"></b-form-feedback>
                                                         </b-col>


                                                         <b-col sm="3" md="3" class="m-t-5px p-a-0">
                                                           <label>Endereço *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Endereço"
                                                                         v-model="form_doctransp.des_endereco"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_endereco')" v-if="form_doctransp.errors.has('des_endereco')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Número *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Número"
                                                                         v-model="form_doctransp.des_numero"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_numero')" v-if="form_doctransp.errors.has('des_numero')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Bairro *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Bairro"
                                                                         v-model="form_doctransp.des_bairro"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_bairro')" v-if="form_doctransp.errors.has('des_bairro')"></b-form-feedback>
                                                         </b-col>

                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Complemento</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Complemento"
                                                                         v-model="form_doctransp.des_complemento"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('des_complemento')" v-if="form_doctransp.errors.has('des_complemento')"></b-form-feedback>
                                                         </b-col>
                                                     </b-row>

                                                     <b-row no-gutters>
                                                         <label><strong>Detalhes</strong></label>
                                                     </b-row>
                                                     <b-row no-gutters>
                                                         <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Tipo *</label>
                                                           <multiselect v-model="form_doctransp.tp_doc"
                                                           :options="optionsLivDocTranspTpDoc"
                                                           track-by="value"
                                                           label="label"
                                                           :hide-selected="true"
                                                           placeholder="Selecione"
                                                           tag-placeholder="Selecionar"
                                                           select-label="Selecionar"
                                                           selected-label="Selecionado"
                                                           deselect-label="Remover"
                                                           ></multiselect>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('tp_doc.value')" v-if="form_doctransp.errors.has('tp_doc.value')"></b-form-feedback>
                                                         </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Nº Fiscal *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Nº Fiscal"
                                                                         v-model="form_doctransp.num_fiscal"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('num_fiscal')" v-if="form_doctransp.errors.has('num_fiscal')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Série *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Série"
                                                                         v-model="form_doctransp.serie"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('serie')" v-if="form_doctransp.errors.has('serie')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Chave</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Chave"
                                                                         v-model="form_doctransp.chave"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('chave')" v-if="form_doctransp.errors.has('chave')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Data *</label>
                                                           <v-date-picker v-model="form_doctransp.dt_emissao"
                                                                          mode='single'
                                                                          locale="pt-BR"
                                                                          v-mask="'##/##/####'"
                                                                          :popover='{visibility: "focus"}'
                                                                          :attributes='date_attributes'
                                                                          :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                                                          @keyup.enter="doFilter">
                                                           </v-date-picker>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('dt_emissao')" v-if="form_doctransp.errors.has('dt_emissao')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="1" md="1" class="m-t-5px p-a-0">
                                                           <label>Volume *</label>
                                                           <b-form-input type="text"
                                                                         placeholder="Volume"
                                                                         v-model="form_doctransp.qtd_volume"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('qtd_volume')" v-if="form_doctransp.errors.has('qtd_volume')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Peso Bruto *</label>
                                                           <b-form-input type="text"
                                                                         v-money="qtd"
                                                                         placeholder="Peso Bruto"
                                                                         v-model="form_doctransp.peso_bruto"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('peso_bruto')" v-if="form_doctransp.errors.has('peso_bruto')"></b-form-feedback>
                                                       </b-col>

                                                       <b-col sm="2" md="2" class="m-t-5px p-a-0">
                                                           <label>Valor Doc. *</label>
                                                           <b-form-input type="text"
                                                                         v-money="vlr"
                                                                         placeholder="Valor Documento"
                                                                         v-model="form_doctransp.vlr_total_cte"
                                                                         >
                                                           </b-form-input>
                                                           <b-form-feedback class="text-danger" v-text="form_doctransp.errors.get('vlr_total_cte')" v-if="form_doctransp.errors.has('vlr_total_cte')"></b-form-feedback>
                                                       </b-col>
                                                      </b-row>
                                                      <b-row>
                                                          <b-col sm="10" md="10">
                                                          </b-col>
                                                          <b-col sm="2" md="2" class="text-right">
                                                              <b-btn variant="secondary" :disabled="isDisabled" v-on:click="addDocTranspDigitacao($event);" v-b-tooltip.hover.right="'Adicionar Documento'" style="cursor: pointer">
                                                              Adicionar
                                                              </b-btn>
                                                          </b-col>
                                                      </b-row>
                                                  </b-container>
                                              </b-tab>
                                          </b-tabs>
                                       </b-tab>
                                    </b-tabs>
                                 </b-col>
                              </b-row>
                           </b-container>
                         </form>

                        <div slot="modal-footer" class="w-100">
                           <div class="float-left col-md-2">
                               <spinner v-if="loading" message="Processando..."></spinner>
                               <spinner v-if="loadingCep" message="buscando endereço..."></spinner>
                               <spinner v-if="loadingAddDoc" message="buscando documento..."></spinner>
                           </div>
                           <div class="float-right col-md-10">
                               <b-row>
                                   <b-col class="text-right">
                                       <div class="float-left" v-if="this.errors_array.length>0">
                                           <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

                                             <b-popover :show.sync="showPopover" target="popoverButton-sync" title="<strong>Erros Encontrados</strong>" data-html="true" placement="leftbottom">
                                               <table class="table-striped" id="mais">
                                                    <tbody>
                                                        <tr class="bg-gray-light" style="display: table-row;" v-for="item in this.errors_array">
                                                           <td>
                                                             {{ item.erro }}
                                                           </td>
                                                       </tr>
                                                   </tbody>
                                               </table>
                                             </b-popover>
                                         </div>
                                   </b-col>
                                   <b-col class="text-right">
                                       <b-form-input type="text"
                                                   placeholder="Qtde"
                                                   v-model="form.qtde_cte"
                                                   name="qtde_cte"
                                                   >
                                       </b-form-input>
                                       <b-form-feedback class="text-danger" v-text="form.errors.get('qtde_cte')" v-if="form.errors.has('qtde_cte')"></b-form-feedback>
                                    </b-col>
                                    <b-col class="text-right">
                                        <b-form-input type="text"
                                                    placeholder="Valor Mercadoria"
                                                    v-money="vlr"
                                                    v-model="form.vlr_mercadoria"
                                                    name="vlr_mercadoria"
                                                    >
                                        </b-form-input>
                                        <b-form-feedback class="text-danger" v-text="form.errors.get('vlr_mercadoria')" v-if="form.errors.has('vlr_mercadoria')"></b-form-feedback>
                                     </b-col>
                                     <b-col>
                                         <label>Usar Chave:</label>
                                     </b-col>
                                     <b-col>
                                           <b-form-radio-group v-model="form.tipo_chave" name="tipo_chave">
                                             <b-form-radio value="1"> NFe</b-form-radio>
                                             <b-form-radio value="2"> Digitada</b-form-radio>
                                           </b-form-radio-group>
                                           <b-form-feedback class="text-danger" v-text="form.errors.get('tipo_chave')" v-if="form.errors.has('tipo_chave')"></b-form-feedback>
                                       </b-col>
                                    <b-col class="text-right">
                                       <b-btn @click="showModal=false" variant="secondary">
                                         Fechar
                                       </b-btn>
                                       <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                                         Enviar
                                       </b-btn>
                                   </b-col>
                               </b-row>
                            </div>
                        </div>
                    </b-modal>
                    <BuscarDocFiscal
                    ref="buscardocfiscal">
                    </BuscarDocFiscal>
                </div>
            </div>
        </div>
</template>

<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import GerarCteFilterBar from './GerarCteFilterBar'
import CteVeiculoDetalhes from './CteVeiculoDetalhes'
import accounting from 'accounting'
import {VMoney} from 'v-money'
import moment from 'moment'
import vueDropzone from 'vue2-dropzone'
import BuscarDocFiscal from '../components/BuscarDocFiscal'

Vue.component('cte-veiculo-detalhes', CteVeiculoDetalhes);

export default {
    name: 'blogisticTour',
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        'vuetable-filterbar': GerarCteFilterBar,
        VMoney,
        vueDropzone,
        BuscarDocFiscal
    },
    data () {
        return {
            callbacksTour: {
              onNextStep: this.tourNextStepCallback,
              onStop: this.tourStop
              },
            steps: [
                {
                  target: '.step-inicio',  // We're using document.querySelector() under the hood
                  content: `Para gerar um CTE é muito fácil. <strong>Veja nossas dicas básicas</strong> para utilizar a tela e as funcionalidades disponíveis`
                },
                {
                  target: '.step-xml-nfe',  // We're using document.querySelector() under the hood
                  content: `Nesta opção você pode importar o XML da NFe que seu cliente lhe enviou. Ao importar a NFe ela será apresentada na listagem abaixo`,
                  params: {
                    placement: 'top'
                  }
                },
                {
                  target: '.step-xml-cte',  // We're using document.querySelector() under the hood
                  content: `Você pode importar xml de CTE também, para gerar seu CTE de redespacho ou redespacho intermediário com mais facilidade`,
                  params: {
                    placement: 'top'
                  }
                },
                {
                  target: '.step-gerar',
                  content: 'Para gerar um CTE, você deve clicar no + ao lado! Para facilitar, você pode selecionar os documentos na listagem abaixo ( NFe importadas ) que irão estar presentes no CTE e clicar no mais, ou, pode clicar diretamente no botão e adicionar os documentos na tela que irá abrir',
                  params: {
                    placement: 'left'
                  }
                },
                {
                  target: '.step-ocultar',
                  content: 'Você pode ocultar um documento da listagem, de forma a não visualizar. Basta selecionar o checkbox no lado esquerdo, e, ocultar em lote. Caso seja necessário reapresentar a NF, você pode filtrar os documentos ocultados.',
                  params: {
                    placement: 'top'
                  }
                },
                {
                  target: '.step-filtrar',
                  content: 'Para filtrar um documento específico, localizar documentos já utilizados, você encontra diversos filtros de documentos importados',
                  params: {
                    placement: 'top'
                  }
                },
            ],
          date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
          modal_titulo: '',
          modal_botao: '',
          modal_acao: '',
          cd_cst: '',
          loading: false,
          isDisabled: false,
          loadingData: true,
          loadingCep: false,
          loadingAddDoc: false,
          showModal: false,
          showModalSelect: false,
          showModalSel: false,
          showModalXml: false,
          showModalHelp: false,
          showPopover: false,
          showPopoverChaveNFe: false,
          showPopoverChaveNFe: false,
          showModalXmlCTe: false,
          optionsParamMotivo: [],
          optionsExpedidor: [],
          optionsRecebedor: [],
          optionsTomador: [],
          optionsLivCfop: [],
          optionsLivTpServico: [],
          optionsModelo: [],
          optionsParamCst: [],
          isLoadingExp: false,
          isLoadingRec: false,
          isLoadingTom: false,
          isFullscreen: false,
          helpForm: new Form({statusRecord: [], params: [],search:'', docs: []
                            , chave: ''
                            , emi_tp_pessoa: []
                            , emi_cnpj_cpf_cuit: ''
                            , emi_ie: ''
                            , emi_nome: ''
                            , emi_cep: ''
                            , emi_numero: ''
                            , emi_bairro: ''
                            , emi_endereco: ''
                            , emi_municipio: []
                            , emi_complemento: ''
                            , des_tp_pessoa: []
                            , des_cnpj_cpf_cuit: ''
                            , des_ie: ''
                            , des_nome: ''
                            , des_cep: ''
                            , des_numero: ''
                            , des_bairro: ''
                            , des_endereco: ''
                            , des_municipio: []
                            , des_complemento: ''
                            , des_pin: ''
                            , tp_doc: []
                            , num_fiscal: ''
                            , serie: ''
                            , dt_emissao: ''
                            , qtd_volume: ''
                            , peso_bruto: 0
                            , vlr_total_nfe: 0
                            , cep_busca: ''
                            }),
          vn_vlr_cte: 0,
          vn_aliquota: 0,
          vn_percentual_reducao_bc: 0,
          activateDesativate: [],
          optionsMunicipioIni: [],
          optionsMunicipioFim: [],
          optionsPortoOrigem: [],
          optionsPortoTransbordo: [],
          optionsPortoDestino: [],
          optionsPortoOrigem: [],
          optionsEmbarcacao: [],
          optionsParamUnidadeMedida: [],
          optionsParamTipoMedida: [],
          optionsParamRespSeg: [],
          optionsSeguradora: [],
          optionsCustos: [],
          optionsLivTpValorCarga: [],
          optionsLivGlobalizado: [],
          optionsLivDocFiscalTpDoc: [],
          optionsLivDocTranspTpDoc: [],
          optionsLivTpPessoa: [],
          optionsMunicipios: [],
          obs_cont: [],
          obs_fisco: [],
          docfis: [],
          docfisDig: [],
          doctransp: [],
          doctranspDig: [],
          errors_array: [],
          carga_medida: [ { medida: [],
                     tipomedida: [],
                     qtde_carga: ''}],

          seguro: [ { respseg: [],
                      seguradora: []}],

          comp_frete: [ { nome: '',
                      vlr: ''}],
          vlr: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          percentual_reducao_bc: {
              decimal: ',',
              prefix: '% ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          aliquota: {
              decimal: ',',
              prefix: '% ',
              precision: 2,
              masked: false /* doesn't work with directive */
          },
          QtdCarga: {
              decimal: ',',
              thousands: '.',
              precision: 3,
              masked: false /* doesn't work with directive */
          },
          qtd: {
             decimal: ',',
             thousands: '.',
             precision: 3,
             masked: false /* doesn't work with directive */
          },
          help_form: new Form({
                    ocultarRecord: [],
                }),
          form: new Form({
                    cst: [],
                    chave_cte_multi: '',
                    chave: '',
                    tp_orig_doc: 1,
                    cfop: [],
                    rntrc: '',
                    cotm: '',
                    tp_servico: [],
                    tp_cte: 0,
                    municipio_ini: [],
                    municipio_fim: [],
                    docs: [],
                    produto_predominante: '',
                    vlr_cte: 0,
                    vlr_carga_averbacao: 0,
                    vlr_aliquota: 0,
                    vlr_imposto: 0,
                    vlr_total: 0,
                    percentual_reducao_bc: 0,
                    docfis: [],
                    doctransp: [],
                    porto_origem: [],
                    porto_transbordo: [],
                    porto_destino: [],
                    embarcacao: [],
                    num_viagem: '',
                    recebedor: [],
                    expedidor: [],
                    tomador: '',
                    globalizado: '',
                    tomador_outros: [],
                    obs: '',
                    tp_valor_carga: [],
                    vlr_aliquota_afrmm: 0,
                    modal: '',
                    carga_medida: [],
                    seguro: [],
                    obs_cont: [],
                    obs_fisco: [],
                    comp_frete: [],
                    modelo_cte: [],
                    doctranspDig: [],
                    docfisDig: [],
                    qtde_cte: 1,
                    vlr_mercadoria: 0,
                    tipo_chave: '',
                }),
                dzOptions: {
                    url: "/api/xmlnfe",
                    maxFiles: 10,
                    maxFilesize: 1,
                    addRemoveLinks: false,
                    thumbnailWidth: 140,
                    thumbnailHeight: 10,
                    uploadMultiple: false,
                    acceptedFiles: ".xml",
                    dictDefaultMessage: 'Arraste os arquivos aqui, ou clique aqui. Limite de 10 arquivos',
                    dictFallbackMessage: 'O seu browser não suporta arrastar para cá. Clique aqui.',
                    dictFallbackText: "Use o formulário alternativo abaixo para envio.",
                    dictFileTooBig: "Arquivo muito grande ({{filesize}}MiB). Tamanho máximo: {{maxFilesize}}MiB.",
                    dictInvalidFileType: "Tipo do arquivo inválido para upload.",
                    dictResponseError: "Server respondeu com código de erro {{statusCode}} code.",
                    dictCancelUpload: "Cancelar envio",
                    dictCancelUploadConfirmation: "Tem certeza que deseja cancelar o envio ?",
                    dictRemoveFile: "Remover arquivo",
                    dictMaxFilesExceeded: "Limite de envio excedido. Atualize a tela.",
                    headers: { "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]').content }
                },
                dzOptionsCTe: {
                    url: "/api/xmlcte",
                    maxFiles: 10,
                    maxFilesize: 1,
                    addRemoveLinks: false,
                    thumbnailWidth: 140,
                    thumbnailHeight: 10,
                    uploadMultiple: false,
                    acceptedFiles: ".xml",
                    dictDefaultMessage: 'Arraste os arquivos aqui, ou clique aqui. Limite de 10 arquivos',
                    dictFallbackMessage: 'O seu browser não suporta arrastar para cá. Clique aqui.',
                    dictFallbackText: "Use o formulário alternativo abaixo para envio.",
                    dictFileTooBig: "Arquivo muito grande ({{filesize}}MiB). Tamanho máximo: {{maxFilesize}}MiB.",
                    dictInvalidFileType: "Tipo do arquivo inválido para upload.",
                    dictResponseError: "Server respondeu com código de erro {{statusCode}} code.",
                    dictCancelUpload: "Cancelar envio",
                    dictCancelUploadConfirmation: "Tem certeza que deseja cancelar o envio ?",
                    dictRemoveFile: "Remover arquivo",
                    dictMaxFilesExceeded: "Limite de envio excedido. Atualize a tela.",
                    headers: { "X-CSRF-TOKEN": document.head.querySelector('meta[name="csrf-token"]').content }
                },
            form_doctransp: new Form({ doctransp: []
                                      , chave: ''
                                      , emi_cnpj_cpf_cuit: ''
                                      , emi_ie: ''
                                      , emi_nome: ''
                                      , emi_cep: ''
                                      , emi_numero: ''
                                      , emi_bairro: ''
                                      , emi_endereco: ''
                                      , emi_municipio: []
                                      , emi_complemento: ''
                                      , des_tp_pessoa: []
                                      , des_cnpj_cpf_cuit: ''
                                      , des_ie: ''
                                      , des_nome: ''
                                      , des_cep: ''
                                      , des_numero: ''
                                      , des_bairro: ''
                                      , des_endereco: ''
                                      , des_municipio: []
                                      , des_complemento: ''
                                      , des_pin: ''
                                      , tp_doc: []
                                      , num_fiscal: ''
                                      , serie: ''
                                      , dt_emissao: ''
                                      , qtd_volume: ''
                                      , peso_bruto: 0
                                      , vlr_total_cte: 0
                                      , cep_busca: ''}),
          fields: [
            {
                name: '__checkbox',
                titleClass: 'center aligned',
                dataClass: 'center aligned'
            },
            {
              name: 'num_fiscal',
              title: 'Nº Fiscal'
            },
            {
              name: 'serie',
              title: 'Serie'
            },
            {
              name: 'dt_emissao',
              title: 'Data Emissão',
              callback: 'formatDate|DD/MM/YYYY'
            },
            {
              name: 'doc_fiscal_partes_env.emi_cnpj',
              title: 'CNPJ'
            },
            {
              name: 'doc_fiscal_partes_env.emi_nome',
              title: 'Razão Social'
            },
            {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
            }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
            detailRowClass: 'vuetable-detail-row',
        },
        moreParams: {}
       }
    },
    directives: {
        money: VMoney,
        aliquota: VMoney,
        qtd: VMoney,
        percentual_reducao_bc: VMoney
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
    },
    methods: {
        onBuscarDoc(data)     {
            this.$refs.buscardocfiscal.onBuscarDocFiscal(data); // PedidoUnidadeCarga
        },
        startTour() {
            this.$tours['blogisticTour'].start();
        },
        tourNextStepCallback(currentStep) {
            // if(currentStep) Abrir o menu com opções
        },
        tourStop(){

        },
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.moreParams = {
                'num_fiscal':  data_filter.num_fiscal,
                'emi_cnpj':  data_filter.emi_cnpj,
                'chave':  data_filter.chave,
                'ocultar':  data_filter.ocultar,
                'utilizadas':  data_filter.utilizadas,
                'dt_inicio': data_filter.dt_inicio,
                'dt_fim': data_filter.dt_fim
            }
            Vue.nextTick( () => this.$refs.vuetable.reload())
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.docfis_id);
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
        },
        onImportXml (data) {
            this.modal_titulo = "Importar XML de NFe";
            this.modal_botao = "Importar";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.$refs.modal_upload_xml.show();
        },
        onImportXmlCte (data) {
            this.modal_titulo = "Importar XML de CTe";
            this.modal_botao = "Importar";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.$refs.modal_upload_xml_cte.show();
        },
        onCreate (data) {
            this.modal_titulo = "Gerar CTE";
            this.modal_botao = "Gerar CTE";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.form.reset();
            this.form.docfis = null;
            this.form.docfis = [];
            this.carga_medida = null;
            this.carga_medida = [];
            this.carga_medida.push({qtde_carga: '', medida: [], tipomedida: []});
            this.comp_frete = null;
            this.comp_frete = [];
            this.comp_frete.push({ custo: [], vlr: '' });
            this.seguro = null;
            this.seguro = [];
            this.form.globalizado = {label: "Não", value: 2};
            this.$refs.vuetable.selectedTo.forEach((obj)=>{
                this.form.docfis.push({ id: obj })
            });
            this.$refs.modal_sel_cte_form.show();
        },
        onGerarCte(e, modal) {
            e.preventDefault();
            this.docfis = null;
            this.docfis = [];
            this.form.vlr_cte = parseInt(0, 10);
            this.form.vlr_carga_averbacao = parseInt(0, 10);
            this.form.vlr_aliquota = parseInt(0, 10);
            this.form.vlr_imposto = parseInt(0, 10);
            this.form.percentual_reducao_bc = parseInt(0, 10);
            this.form.vlr_total = parseInt(0, 10);
            this.form.vlr_aliquota_afrmm = parseInt(0, 10);
            // Caso tenha sido selecionado modelo
            if(this.form.modelo_cte.value>0)
            {
                this.form.cst = { label: this.form.modelo_cte.mod.param_cst.cd+" - "+this.form.modelo_cte.mod.param_cst.descr, cd: this.form.modelo_cte.mod.param_cst.cd, value: this.form.modelo_cte.mod.param_cst.parcst_id };
                this.form.produto_predominante = this.form.modelo_cte.mod.produto_predominante;
                this.form.vlr_cte = this.formatNumber(this.form.modelo_cte.mod.vlr_cte);
                this.form.vlr_aliquota = this.formatNumber(this.form.modelo_cte.mod.aliquota_icms);
                this.form.vlr_imposto = this.formatNumber(this.form.modelo_cte.mod.vlr_imposto);
                this.form.percentual_reducao_bc = this.formatNumber(this.form.modelo_cte.mod.percentual_reducao_bc);
                this.form.tp_servico = { label: this.form.modelo_cte.mod.tp_servico.descr, value: this.form.modelo_cte.mod.tp_servico.valor };
                this.form.globalizado = { label: this.form.modelo_cte.mod.globalizado.descr, value: this.form.modelo_cte.mod.globalizado.valor };
                this.form.tp_valor_carga = { label: this.form.modelo_cte.mod.tp_valor_carga.descr, value: this.form.modelo_cte.mod.tp_valor_carga.valor };
                this.form.obs = this.form.modelo_cte.mod.obs;
                this.form.tomador = this.form.modelo_cte.mod.tomador;
                this.form.cfop = { label: this.form.modelo_cte.mod.cfop.cd+" - "+this.form.modelo_cte.mod.cfop.descr, value: this.form.modelo_cte.mod.cfop.cfop_id, cd: this.form.modelo_cte.mod.cfop.cd };
                this.form.municipio_ini = { label: this.form.modelo_cte.mod.municipio_inicio.nome+" - "+this.form.modelo_cte.mod.municipio_inicio.cd_ibge, value: this.form.modelo_cte.mod.municipio_inicio.municipio_id };
                this.form.municipio_fim = { label: this.form.modelo_cte.mod.municipio_fim.nome+" - "+this.form.modelo_cte.mod.municipio_fim.cd_ibge, value: this.form.modelo_cte.mod.municipio_fim.municipio_id };

                this.carga_medida = null;
                this.carga_medida = [];
                this.form.modelo_cte.mod.modelo_cte_carga.forEach((obj)=>{
                    this.carga_medida.push({ qtde_carga: parseInt(obj.qtd, 10), medida: {label: obj.param_unidade_medida.descr, value: obj.param_unidade_medida.parunidmed_id}, tipomedida: {label: obj.param_tipo_medida.descr, value: obj.param_tipo_medida.partpmed_id} })
                });

                this.comp_frete = null;
                this.comp_frete = [];
                this.form.modelo_cte.mod.modelo_cte_comp_frete.forEach((obj)=>{
                    this.comp_frete.push({ custo: {label: obj.custo.descr+" - "+obj.custo.cd, value: obj.custo.custo_id}, vlr: parseInt(obj.vlr, 10)})
                });

                this.seguro = null;
                this.seguro = [];
                this.form.modelo_cte.mod.modelo_cte_seguro.forEach((obj)=>{
                    this.seguro.push({ respseg: {label: obj.param_tipo_resp_seg.descr, value: obj.param_tipo_resp_seg.cd}, seguradora: {label: obj.seguradora.descr, value: obj.seguradora.cd}, segurado_id: obj.seguradora.segurado_id, nome: obj.seguradora.nome, partprese_id:  obj.param_tipo_resp_seg.partprese_id })
                });

                // Calcula o valor do CTe
                this.calcCte();
            }

            this.form.docfis.forEach((docfis_id)=>{
                this.$refs.vuetable.tableData.forEach((obj)=>{
                    if(obj.docfis_id==docfis_id.id)
                    {
                        this.docfis.push({  id: obj.docfis_id,
                                            chave: obj.chave,
                                            num_fiscal: obj.num_fiscal,
                                            serie: obj.serie,
                                            dt_emissao: obj.dt_emissao,
                                            emi_nome: obj.doc_fiscal_partes_env.emi_nome,
                                            emi_cnpj: obj.doc_fiscal_partes_env.emi_cnpj,
                                            des_nome: obj.doc_fiscal_partes_env.des_nome,
                                            des_cnpj: obj.doc_fiscal_partes_env.des_cnpj,
                                            tp_doc: obj.liv_tp_doc,
                                            tp_doc_descr: obj.liv_tp_doc.label
                                         })
                    }
                });
            });
            this.modal_titulo = "Gerar CTE";
            this.modal_botao = "Gerar CTE";
            this.modal_acao = "i";
            this.loading = false;
            this.isDisabled = false;
            this.form.modal = modal;
            this.$refs.modal_sel_cte_form.hide();
            this.$refs.modal_form.show();
        },
        calcCte() {
            this.vn_vlr_cte = this.form.vlr_cte;
            this.vn_aliquota = this.form.vlr_aliquota;
            this.form.vlr_imposto = Number((this.vn_vlr_cte/((100-this.vn_aliquota)/100))-this.vn_vlr_cte);
            this.vn_vlr_total = this.vn_vlr_cte+this.form.vlr_imposto;
            this.form.vlr_total = Number(this.vn_vlr_total);
        },
        onStore() {
            this.loading = true;
            this.isDisabled = true;
            this.form.tp_orig_doc = 1; // Gerar CTE
            this.form.carga_medida = this.carga_medida;
            this.form.seguro = this.seguro;
            this.form.obs_cont = this.obs_cont;
            this.form.obs_fisco = this.obs_fisco;
            this.form.comp_frete = this.comp_frete;
            this.form.docfis = this.docfis;
            this.form.docfisDig = this.docfisDig;
            this.form.doctransp = this.doctransp;
            this.form.doctranspDig = this.doctranspDig;
            this.form.post('/api/ctelote/store').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {

                new ReturnApi(errors, this)
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
            });
        },
        addDoc() {
            this.loadingAddDoc = true;
            this.isDisabledAddDoc = true;
            this.helpForm.docs = this.docfis;
            this.helpForm.dt_emissao = this.formatDateSubmit(this.helpForm.dt_emissao);
            this.helpForm.post('/api/associar/adddoc').then(response =>
            {
                this.docfis.push({
                    id: response.docfis_id,
                    chave: response.chave,
                    num_fiscal: response.num_fiscal,
                    serie: response.serie,
                    dt_emissao: response.dt_emissao,
                    emi_nome: response.doc_fiscal_partes_env.emi_nome,
                    emi_cnpj: response.doc_fiscal_partes_env.emi_cnpj,
                    des_nome: response.doc_fiscal_partes_env.des_nome,
                    des_cnpj: response.doc_fiscal_partes_env.des_cnpj,
                    tp_doc: response.liv_tp_doc,
                    tp_doc_descr: response.liv_tp_doc.label
                });
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                this.helpForm.chave = "";
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                new ReturnApi(errors, this)
            });
        },
        addDocDigitacao() {
            this.loadingAddDoc = true;
            this.isDisabledAddDoc = true;
            this.helpForm.docs = this.docfis;
            // Ajustar para adicionar CTE's globalizados #REVISAR#
            // Chamada backend para validar
            this.helpForm.dt_emissao = this.formatDateSubmit(this.helpForm.dt_emissao);
            this.helpForm.post('/api/associar/adddocdigitacao').then(response =>
            {
                this.docfisDig.push({
                    emi_tp_pessoa: this.helpForm.emi_tp_pessoa,
                    emi_cnpj_cpf_cuit: this.helpForm.emi_cnpj_cpf_cuit,
                    emi_ie: this.helpForm.emi_ie,
                    emi_nome: this.helpForm.emi_nome,
                    emi_cep: this.helpForm.emi_cep,
                    emi_numero: this.helpForm.emi_numero,
                    emi_bairro: this.helpForm.emi_bairro,
                    emi_endereco: this.helpForm.emi_endereco,
                    emi_municipio: this.helpForm.emi_municipio,
                    emi_complemento: this.helpForm.emi_complemento,
                    des_tp_pessoa: this.helpForm.des_tp_pessoa,
                    des_cnpj_cpf_cuit: this.helpForm.des_cnpj_cpf_cuit,
                    des_ie: this.helpForm.des_ie,
                    des_nome: this.helpForm.des_nome,
                    des_cep: this.helpForm.des_cep,
                    des_numero: this.helpForm.des_numero,
                    des_bairro: this.helpForm.des_bairro,
                    des_endereco: this.helpForm.des_endereco,
                    des_municipio: this.helpForm.des_municipio,
                    des_complemento: this.helpForm.des_complemento,
                    tp_doc: this.helpForm.tp_doc,
                    tp_doc_descr: this.helpForm.tp_doc.label,
                    chave: this.helpForm.chave,
                    num_fiscal: this.helpForm.num_fiscal,
                    serie: this.helpForm.serie,
                    dt_emissao: this.helpForm.dt_emissao,
                    qtd_volume: this.helpForm.qtd_volume,
                    peso_bruto: this.helpForm.peso_bruto,
                    vlr_total_nfe: this.helpForm.vlr_total_nfe,
                });

                this.loadingAddDoc = false;
                this.helpForm.chave = "";
                this.helpForm.reset();
                this.isDisabledAddDoc = false;
                vm.$snotify.success(response.message, response.title);
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
                new ReturnApi(errors, this)
            });
        },
        onBuscarDocAssociar(data){
            var c = true;
            data.forEach((obj)=>
            {
                c = true;
                this.docfis.forEach((obj2)=>{
                    if(obj2.id==obj.id)
                    {
                        c = false;
                    }
                });

                if(c)
                {
                    this.docfis.push({
                        id : obj.id,
                        chave : obj.chave,
                        num_fiscal : obj.num_fiscal,
                        serie : obj.serie,
                        dt_emissao : obj.dt_emissao,
                        emi_nome: obj.emi_nome,
                        emi_cnpj: obj.emi_cnpj,
                        des_nome: obj.des_nome,
                        des_cnpj: obj.des_cnpj,
                        tp_doc: obj.tp_doc
                    });
                }
            })
            this.$refs.modal_form.show();
        },
        onVoltar() {
            this.$refs.modal_form.show();
        },
        onShowHelp() {
            this.modal_titulo = "Ajuda";
            this.modal_acao = "i";
            this.showModalHelp = true;
        },
        addDocTransp() {
            this.loading = true;
            this.isDisabled = true;
            this.form_doctransp.doctransp = this.doctransp;
            this.form_doctransp.dt_emissao = this.formatDateSubmit(this.form_doctransp.dt_emissao);
            this.form_doctransp.post('/api/gerarcte/adddoctransp').then(response =>
            {
                this.doctransp.push({
                    id: response.doctransp_id,
                    chave: response.chave,
                    num_fiscal: response.num_doc,
                    serie: response.serie,
                    dt_emissao: response.dt_emissao,
                    emi_nome: response.doc_transp_partes_env.emi_nome,
                    emi_cnpj: response.doc_transp_partes_env.emi_cnpj,
                    des_nome: response.doc_transp_partes_env.des_nome,
                    des_cnpj: response.doc_transp_partes_env.des_cnpj,
                    tp_doc: response.liv_tp_doc,
                    tp_doc_descr: response.liv_tp_doc.label
                });
                this.form_doctransp.chave = "";
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getLivGeral() {
            this.helpForm.get('/api/gerarcte/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.param_cst.forEach((obj)=>
                {
                    this.optionsParamCst.push({ label: obj.cd+" - "+obj.descr, value: obj.parcst_id, cd: obj.cd })
                })

                response.cfops.forEach((obj)=>
                {
                    this.optionsLivCfop.push({ label: obj.cd+" - "+obj.descr, value: obj.cfop_id })
                })

                response.tp_servico.forEach((obj)=>
                {
                    this.optionsLivTpServico.push({ label: obj.valor+" - "+obj.descr, value: obj.valor })
                })

                response.municipios.forEach((obj)=>
                {
                    this.optionsMunicipioIni.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                    this.optionsMunicipioFim.push({ label: obj.nome+" - "+obj.cd_ibge, value: obj.municipio_id })
                    this.optionsMunicipios.push({ label: obj.nome, ibge: obj.cd_ibge, value: obj.municipio_id })
                })
                response.portos.forEach((obj)=>
                {
                    this.optionsPortoOrigem.push({ label: obj.nome+" - "+obj.cd, value: obj.porto_id })
                    this.optionsPortoTransbordo.push({ label: obj.nome+" - "+obj.cd, value: obj.porto_id })
                    this.optionsPortoDestino.push({ label: obj.nome+" - "+obj.cd, value: obj.porto_id })
                })
                response.embarcacao.forEach((obj)=>
                {
                    this.optionsEmbarcacao.push({ label: obj.nome+" - "+obj.irin, value: obj.embarcacao_id })
                })
                response.tp_valor_carga.forEach((obj)=>
                {
                    this.optionsLivTpValorCarga.push({ label: obj.descr, value: obj.valor })
                })

                response.globalizado.forEach((obj)=>
                {
                    this.optionsLivGlobalizado.push({ label: obj.descr, value: obj.valor })
                })

                response.medida.forEach((obj)=>
                {
                    this.optionsParamUnidadeMedida.push({ label: obj.descr+" - "+obj.cd, value: obj.parunidmed_id })
                })
                response.tipomedida.forEach((obj)=>
                {
                    this.optionsParamTipoMedida.push({ label: obj.descr+" - "+obj.cd, value: obj.partpmed_id })
                })
                response.respseg.forEach((obj)=>
                {
                    this.optionsParamRespSeg.push({ label: obj.descr+" - "+obj.cd, value: obj.partprese_id })
                })
                response.seguradora.forEach((obj)=>
                {
                    this.optionsSeguradora.push({ label: obj.nome+" - "+obj.apolice, value: obj.segurado_id })
                })
                response.custos.forEach((obj)=>
                {
                    this.optionsCustos.push({ label: obj.descr+" - "+obj.cd, value: obj.custo_id })
                })

                response.doc_fiscal_tp_doc.forEach((obj)=>
                {
                    this.optionsLivDocFiscalTpDoc.push({ label: obj.descr, value: obj.valor })
                })

                response.doc_transp_tp_doc.forEach((obj)=>
                {
                    this.optionsLivDocTranspTpDoc.push({ label: obj.descr, value: obj.valor })
                })

                response.tp_pessoa.forEach((obj)=>
                {
                    this.optionsLivTpPessoa.push({ label: obj.descr, value: obj.valor })
                })

                response.modelo_cte.forEach((obj)=>
                {
                    this.optionsModelo.push({ label: obj.descr+" - "+obj.cd, value: obj.modcte_id , mod: obj})
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        addDocTranspDigitacao() {
            this.loadingAddDoc = true;
            this.isDisabledAddDoc = true;
            this.form_doctransp.doctransp = this.doctranspDig;
            // Chamada backend para validar
            this.form_doctransp.dt_emissao = this.formatDateSubmit(this.form_doctransp.dt_emissao);
            this.form_doctransp.post('/api/associar/adddoctranspdigitacao').then(response =>
            {
                this.doctranspDig.push({
                    emi_cnpj_cpf_cuit: this.form_doctransp.emi_cnpj_cpf_cuit,
                    emi_ie: this.form_doctransp.emi_ie,
                    emi_nome: this.form_doctransp.emi_nome,
                    emi_cep: this.form_doctransp.emi_cep,
                    emi_numero: this.form_doctransp.emi_numero,
                    emi_bairro: this.form_doctransp.emi_bairro,
                    emi_endereco: this.form_doctransp.emi_endereco,
                    emi_municipio: this.form_doctransp.emi_municipio,
                    emi_complemento: this.form_doctransp.emi_complemento,
                    des_tp_pessoa: this.form_doctransp.des_tp_pessoa,
                    des_cnpj_cpf_cuit: this.form_doctransp.des_cnpj_cpf_cuit,
                    des_ie: this.form_doctransp.des_ie,
                    des_nome: this.form_doctransp.des_nome,
                    des_cep: this.form_doctransp.des_cep,
                    des_numero: this.form_doctransp.des_numero,
                    des_bairro: this.form_doctransp.des_bairro,
                    des_endereco: this.form_doctransp.des_endereco,
                    des_municipio: this.form_doctransp.des_municipio,
                    des_complemento: this.form_doctransp.des_complemento,
                    des_pin: this.form_doctransp.des_pin,
                    tp_doc: this.form_doctransp.tp_doc,
                    tp_doc_descr: this.form_doctransp.tp_doc.label,
                    chave: this.form_doctransp.chave,
                    num_fiscal: this.form_doctransp.num_fiscal,
                    serie: this.form_doctransp.serie,
                    dt_emissao: this.form_doctransp.dt_emissao,
                    qtd_volume: this.form_doctransp.qtd_volume,
                    peso_bruto: this.form_doctransp.peso_bruto,
                    vlr_total_cte: this.form_doctransp.vlr_total_cte
                });

                this.loadingAddDoc = false;

                this.form_doctransp.chave = "";
                this.form_doctransp.reset();
                this.isDisabledAddDoc = false;
                vm.$snotify.success(response.message, response.title);
                new ReturnApi(response, this);
            })
            .catch(errors =>
            {
                this.loadingAddDoc = false;
                this.isDisabledAddDoc = false;
                this.errors_array = '';
                this.errors_array = [];
                for(var property in errors)
                {
                  if(errors.hasOwnProperty(property))
                  {
                     if(typeof(errors[property]) === 'object')
                     {
                     errors[property].forEach((obj)=>{
                        this.errors_array.push({erro: obj});
                     });
                     }
                  }
                }
                new ReturnApi(errors, this)
            });
        },
        formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
            return (value == null || value == "")
              ? ''
              : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
        listaClientesExpedidor(search) {
            if(search.length>=3)
            {
                this.isLoadingExp = true;
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsExpedidor = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsExpedidor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingExp = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesRecebedor(search) {
            if(search.length>=3)
            {
                this.isLoadingRec = true;
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsRecebedor = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsRecebedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingRec = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        listaClientesTomador(search) {
            if(search.length>=3)
            {
                this.isLoadingTom = true;
                this.helpForm.search = search;
                this.helpForm.post('/api/pessoa/jsonlist').then(response =>
                {
                    this.optionsTomador = [];
                    new ReturnApi(response, this, true, false, false);
                    response.items.forEach((obj)=>
                    {
                        this.optionsTomador.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                    });
                    this.isLoadingTom = false;
                })
                .catch(errors =>
                {
                    new ReturnApi(errors, this)
                });
            }
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito)
        {
            var cnpj_formatado
            var pad = "00000000"
            var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
            var pad = "0000"
            var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
            var pad = "00"
            var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;

            return cnpj_base+""+cnpj_filial+""+cnpj_digito;
        },
        addRowCompFrete: function(e) {
            e.preventDefault();
            this.comp_frete.push({
                custo: "",
                vlr: "",
            });
        },
        removeRowCompFrete: function(index) {
            this.comp_frete.splice(index, 1);
        },
        addRowObsCont: function(e) {
            e.preventDefault();
            this.obs_cont.push({
                xcampo: "",
                xtexto: "",
            });
        },
        removeRowObsCont: function(index) {
            this.obs_cont.splice(index, 1);
        },
        addRowObsFisco: function(e) {
            e.preventDefault();
            this.obs_fisco.push({
                xcampo: "",
                xtexto: "",
            });
        },
        removeRowObsFisco: function(index) {
            this.obs_fisco.splice(index, 1);
        },
        addRowSeguro: function(e) {
            e.preventDefault();
            this.seguro.push({
                seguradora: [],
                partprese: [],
            });
        },
        removeRowSeguro: function(index) {
            this.seguro.splice(index, 1);
        },
        addRowCarga: function(e) {
            e.preventDefault();
            this.carga_medida.push({
                partpmed: [],
                parunidmed: [],
                qtde_carga: '',
            });
        },
        removeRowCarga: function(index) {
            this.carga_medida.splice(index, 1);
        },
        removeRowDoc: function(index) {
            this.docfis.splice(index, 1);
        },
        removeRowDocDig: function(index) {
            this.docfisDig.splice(index, 1);
        },
        removeRowDocTransp: function(index) {
            this.doctransp.splice(index, 1);
        },
        removeRowDocTranspDig: function(index) {
            this.doctranspDig.splice(index, 1);
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        formatNumberQtd (value) {
            return accounting.formatNumber(value, 3, '.', ',')
        },
        showSuccess: function (file, message, xhr) {
            this.$snotify.success(message+' para arquivo '+file.name);
            Vue.nextTick( () => this.$refs.vuetable.refresh());
        },
        showError: function (file, message, xhr) {
            this.$snotify.error(message+' para arquivo '+file.name);
        },
        showErrorCTe: function (file, message, xhr) {
            this.$snotify.error(message.message+' para arquivo '+file.name);
        },
        sendingEvent (file, xhr, formData) {
            formData.append('paramName', 'some value or other');
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
        formatTypedDate: function (dateString)
        {
           let result = dateString.split('/')
           return result[2] + '-' + result[1] + '-' + result[0] + 'T00:00:00-03:00'
        },
        onOcultar(action, data, tipo)
        {
            // Tipo = true = Checkbox
            if(tipo)
            {
                this.help_form.ocultarRecord = [];
                this.help_form.ocultarRecord.push({ id: data.docfis_id, status: action });
            }
            else
            {
                this.help_form.ocultarRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.help_form.ocultarRecord.push({ id: obj, status: action })
                });
            }

            this.loading = true;
            this.isDisabled = true;
            this.help_form.post('/api/gerarcte/ocultar').then(response =>
            {
                new ReturnApi(response, this)
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        getCep(en_tipo)
        {
            if(en_tipo==1)
            {
                this.helpForm.cep_busca = this.helpForm.emi_cep;
            }
            else if(en_tipo==2)
            {
                this.helpForm.cep_busca = this.helpForm.des_cep;
            }
            else if(en_tipo==3)
            {
                this.helpForm.cep_busca = this.form_doctransp.emi_cep;
            }
            else if(en_tipo==4)
            {
                this.helpForm.cep_busca = this.form_doctransp.des_cep;
            }

            //Nova variável "cep" somente com dígitos.
            var cep = this.helpForm.cep_busca.replace(/\D/g, '');

            //Verifica se campo cep possui valor informado.
            if (cep != "")
            {

                //Expressão regular para validar o CEP.
                var validacep = /^[0-9]{8}$/;

                //Valida o formato do CEP.
                if(validacep.test(cep))
                {
                    this.loadingCep = true;
                    this.helpForm.post('/api/cep/pesquisar').then(response =>
                    {
                        new ReturnApi(response, this, true, false, false);

                        if(en_tipo==1)
                        {
                            this.helpForm.errors.clear();
                            response.forEach((obj)=>{
                                this.helpForm.emi_endereco = obj.logradouro;
                                this.helpForm.emi_bairro = obj.bairro;
                                this.helpForm.emi_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.helpForm.emi_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        else if(en_tipo==2)
                        {
                            this.helpForm.errors.clear();
                            response.forEach((obj)=>{
                                this.helpForm.des_endereco = obj.logradouro;
                                this.helpForm.des_bairro = obj.bairro;
                                this.helpForm.des_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.helpForm.des_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        else if(en_tipo==3)
                        {
                            this.form_doctransp.errors.clear();
                            response.forEach((obj)=>{
                                this.form_doctransp.emi_endereco = obj.logradouro;
                                this.form_doctransp.emi_bairro = obj.bairro;
                                this.form_doctransp.emi_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.form_doctransp.emi_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        else if(en_tipo==4)
                        {
                            this.form_doctransp.errors.clear();
                            response.forEach((obj)=>{
                                this.form_doctransp.des_endereco = obj.logradouro;
                                this.form_doctransp.des_bairro = obj.bairro;
                                this.form_doctransp.des_complemento = obj.complemento;
                                this.optionsMunicipios.forEach((obj2)=>{
                                    if(obj2.ibge==obj.ibge)
                                    {
                                        this.form_doctransp.des_municipio = { label: obj2.label, value: obj2.value };
                                    }
                                });
                            });
                        }
                        this.loadingCep = false;

                    })
                    .catch(errors =>
                    {
                        this.loadingCep = false;
                        new ReturnApi(errors, this)
                    });
                }
                else
                {
                    if(en_tipo==1)
                    {
                        var errors = { "errors": { "emi_cep": [ "Cep inválido"] }};
                        this.helpForm.errors.record(errors.errors);
                    }
                    else if(en_tipo==2)
                    {
                        var errors = { "errors": { "des_cep": [ "Cep inválido"] }};
                        this.helpForm.errors.record(errors.errors);
                    }
                    else if(en_tipo==3)
                    {
                        var errors = { "errors": { "emi_cep": [ "Cep inválido"] }};
                        this.form_doctransp.errors.record(errors.errors);
                    }
                    else if(en_tipo==4)
                    {
                        var errors = { "errors": { "des_cep": [ "Cep inválido"] }};
                        this.form_doctransp.errors.record(errors.errors);
                    }
                }
            }
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        },
      getCurrency: {
        get() {
          return this.$store.getters.currency;
        }
      },
        certificado_instalado: {
            get() {
                return this.$store.getters.certificado_instalado;
            }
        },
        produto_predominante_left() {
            var char = this.form.produto_predominante.length,
            limit = 60;
            return (limit - char) + " / " + limit + " caracteres disponíveis";
        },
        obs_left() {
            var char = this.form.obs.length,
            limit = 2000;
            return (limit - char) + " / " + limit + " caracteres disponíveis";
        },
    }
}
</script>
